import ReactDOM from "react-dom/client";
import React, { useEffect, useState } from 'react';
import { Container, Title, TableWrapper, SubTable, SubTableFor, SubTableRow, SubTableCell, SubTableForCell, ExpandButton, TableCell, TableText, SubTitle, TableBoot, SubTableCellLarger, NormalFont, RedFont, GreenFont, CustomizeLI, TextAlign, BlackFont, MarginButton, TdFixed, ThFixed, TheadFixed, DadosTD, MapaScrollArea, MapaTable } from './styles';
import { Button, Col, FormControl, FormLabel, Row, Tooltip } from 'react-bootstrap';
import InputGeral from '../../../components/InputGeral/Index';
import SubmitForm from "../../../components/SubmitForm";
import SelectCondicaoPagamento from '../../../components/Select/CondicaoPagamento';
import ConsultaCotacao from "../../../../lib/json/consultas/Cotacao.json"
import ConsultaCondPagto from "../../../../lib/json/consultas/CondicaoPagamento.json"
import { ConsultaTotvsEmpresa } from '../../../../backend/ConsultaTotvsEmpresa';
import { useParams } from 'react-router-dom';
import { calcularDiferencaEmDias, converteDataProtheus, convertSpecialCharsToHtml, decryptAES, encryptAES, ErroMsg, formatarComoDecimal, formatarComoMoeda, formatarMoeda, formatarMoeda2, parseLocaleNumber, SucessoMsg } from '../../../contents/VariaveisGlobais';
import TitlePageTotvs from '../../../components/TitlePageTotvs';
import IconComponent from '../../../components/Icons';
import SelectFixo from '../../../components/SelectFixo';
import $ from 'jquery';
import UltimasCompras from '../../../components/UltimasCompras';
import { usePopUp } from '../../../components/BootBox';
import LoadingSpinner from '../../../components/LoadinSpinner';
import ConsumoTOTVS_POST from '../../../../backend/ConsumoTotvs';
import { LabelInput } from '../../../components/InputGeral/styles';
import UploadFiles from '../../../components/UploadFiles';
import { toast } from 'react-toastify';
import { ConsumoAPI_FileUpload } from '../../../../backend/ConsumoAPI';
import { format, parse } from 'date-fns';
import MapaCotacaoPDF from '../MapaCotacaoPDF';
import ResponsiveDataTable from '../../../components/DataTable';
import { handleData, handleValorTotal } from '../../../components/GridCell/Preco';

var dadosDesmembrados = []

const MapaCotacaoFornecedor = ({ encryptedText: propEncryptedText, Cotacao}) => {
	const currentDate = new Date()

	const [carregar, setCarregar] = useState(false);
	const [expanded, setExpanded] = useState({});
	const [dataDesmembramento, setDataDesmembramento] = useState([]);	
	const [urlHomologacao, setUrlHomologacao] = useState();
	const [empresa, setEmpresa] = useState();
	const [empresaFilial, setEmpresaFilial] = useState();
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState();
	const [campoAnexosCotacao, setCampoAnexosCotacao] = useState([]);
	const [produtos, setProdutos] = useState([])
	const [finalizado, setFinalizado] = useState(false)
	const [expiradoData, setExpiradoData] = useState(false)
	const [numeroCotacao, setNumeroCotacao] = useState([])
	const [homologado, setHomologado] = useState(false)
	const [cotacaoExcluida, setCotacaoExcluida] = useState(false)
	const [anexoProposta, setAnexoProposta] = useState([])
	const [campoExibeMapa, setCampoExibeMapa] = useState([{value: 'Respondidos', text: 'Somente Respondidos'}])
	const [dataMinima, setDataMinima] = useState(format(currentDate, 'yyyy-MM-dd'));
	const [optionsSelecao, setOptionsSelecao] = useState([{
		value: 'Todos',
		text: "Todos",
	},
	{
		value: 'Respondidos',
		text: "Somente Respondidos",
	}]);

	const { '*': CotacaoURL } = useParams();
    const CotacaoTela = propEncryptedText || CotacaoURL;

	const { DisparaBootBox, FechaBootBox } = usePopUp();

	let cConsultaCondPgto = ConsultaCondPagto.consulta + " WHERE D_E_L_E_T_ <> '*' AND E4_FILIAL = FILIAL(SE4) AND E4_MSBLQL != 1 "
	
	if (window._env_?.REACT_APP_CONDICOES_PAGAMENTO && !CotacaoTela){
		cConsultaCondPgto += ` AND E4_CODIGO IN ('${window._env_?.REACT_APP_CONDICOES_PAGAMENTO.replaceAll(',', "','")}')`
	}

	const usuarioLogado = CotacaoTela ? JSON.parse(localStorage.getItem('usuarioLogado')) : '';
	const usuarioProtheus = usuarioLogado ? JSON.parse(usuarioLogado.usuarioProtheus) : []

	var chaveItemCotacao = "";
	var chaveAnexos = "";
	var quantidadeDesmembrar = 0;		
	var campoAnexos = [];
	
	// useEffect( () => { if (produtos) { handleMelhorPreco(false); } }, [produtos])
	
	useEffect( () => {
		const fetchData = async() => {
			setCarregar(true)
			let dadosCotacaoURL = []
			let habilitaDigitacao = true

			if (CotacaoTela){
				const secretKeyCotacao = window._env_?.REACT_APP_KEY_COTACAO
                const cotacaoDecrypt = decryptAES(CotacaoTela, secretKeyCotacao)
                
                dadosCotacaoURL = JSON.parse(cotacaoDecrypt)
				habilitaDigitacao = false;
			}
			
			const dadosCotacao = Cotacao || dadosCotacaoURL;
			setEmpresaFilial(dadosCotacao.Filial)
			setNumeroCotacao(dadosCotacao.Numero)
			
			if (dadosCotacao){
				let camposAdicionais = ", C8_OK, C8_UM, C8_QUANT, C8_ITEM, C8_IDENT, C8_NUMSC, C8_ITEMSC "
				camposAdicionais += ", CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C8_XOBS))) C8_XOBS, C8_XDTENT, C8_PRECO, C8_VALICM, C8_VALIPI, C8_XICMST, C8_XDIFAL, C8_XISS "
				camposAdicionais += ", C8_COND, C8_XDVFOR, CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C8_OBS))) C8_OBS "
				camposAdicionais += ", CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C8_XANXCOT))) C8_XANXCOT "
				camposAdicionais += ", CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C8_XANXMAP))) C8_XANXMAP "
				camposAdicionais += ", CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C1_XANEXO))) C1_XANEXO "
				camposAdicionais += ", CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C8_XOFOR))) C8_XOFOR, CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C8_XJUST))) C8_XJUST "
				camposAdicionais += ", CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C8_XOBSCOT))) C8_XOBSCOT "
				camposAdicionais += ", C8_VALFRE, C8_TPFRETE, C8_XMPRESP, C8_NUMPED, C8_NUMCON, C8_XCA "
				camposAdicionais += ", A2_CGC, A2_XTPFORN, A2_MEDIA, A2_COND,  C8_FORNECE, C8_LOJA, C8_FORNOME, C8_XCODCON, C8_CONTATO, C8_FORMAIL, C8_XFORTEL, C8_XFORCEL "
				camposAdicionais += ", C1_NUM, C1_ITEM, C1_PRODUTO, CASE WHEN B5_CEME != '' THEN B5_CEME ELSE C1_DESCRI END AS DESCRI, C1_OBS, C1_CC, C1_XENDENT, C1_EMISSAO, C1_DATPRF, C1_XDTAPRV, C1_XCA, C1_XPERIO, C1_XLOC "
				camposAdicionais += ", (SELECT TOP 1 E4_DESCRI FROM TABELA(SE4) SE4 WHERE E4_FILIAL = FILIAL(SE4) AND E4_CODIGO = A2_COND AND SE4.D_E_L_E_T_ <> '*' ) COND_A2 "
				camposAdicionais += ", (SELECT TOP 1 CTT_DESC01 FROM TABELA(CTT) CTT WHERE CTT_FILIAL = FILIAL(CTT) AND CTT_CUSTO = C1_CC AND CTT.D_E_L_E_T_ <> '*' ) CTT_DESC01 "
				camposAdicionais += ", (SELECT TOP 1 E4_DESCRI FROM TABELA(SE4) SE4 WHERE E4_FILIAL = FILIAL(SE4) AND E4_CODIGO = C8_COND AND SE4.D_E_L_E_T_ <> '*' ) E4_DESCRI "
				camposAdicionais += ", (SELECT TOP 1 ROUND(C7_TOTAL / C7_QUANT, 4) FROM TABELA(SC7) SC7 WHERE C7_FORNECE = C8_FORNECE AND C7_LOJA = C8_LOJA AND C7_PRODUTO = C1_PRODUTO AND SC7.D_E_L_E_T_ <> '*' ORDER BY C7_EMISSAO DESC ) ULTPRC "
				camposAdicionais += ", (SELECT TOP 1 ROUND(C7_TOTAL / C7_QUANT, 4) FROM TABELA(SC7) SC7 WHERE C7_PRODUTO = C1_PRODUTO AND SC7.D_E_L_E_T_ <> '*' ORDER BY C7_EMISSAO DESC ) ULTPRCGRL "
				//Adicionar Opção Ultimo Preço

				let cEmpresaFilial = dadosCotacao.Filial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + dadosCotacao.Filial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL)
				let consultaDefault = ConsultaCotacao.consulta.replace('[CAMPOS]', camposAdicionais);
				consultaDefault += " AND C8_FILIAL = FILIAL(SC8)"
				consultaDefault += " AND C8_NUM = '" + dadosCotacao.Numero + "'"
				
				if (dadosCotacao.Fornecedor){
					consultaDefault += " AND C8_FORNECE = '" + dadosCotacao.Fornecedor + "'"
					consultaDefault += " AND C8_LOJA = '" + dadosCotacao.Loja + "'"
				}
				consultaDefault += " ORDER BY C8_FILIAL, C8_NUM, C8_ITEM, C8_FORNECE, C8_LOJA"
				// consultaDefault += " ORDER BY C8_FILIAL, C8_NUM, C8_ITEM, C8_XSQCOT, C8_XQTPEDC8,C8_FORNECE, C8_LOJA"

				var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, ConsultaCotacao.tabelas + ";SC7;SE4;CTT", cEmpresaFilial );
            
        		if (retConsulta.error === '00' && retConsulta.data.length > 0){
					const originalArray = retConsulta.data
					const nMediaHomologado = window._env_?.REACT_APP_MEDIA_HOMOLOGACAO
                	const lFornecedorHomologado = CotacaoTela ? true : (originalArray[0].A2_XTPFORN === 'N' || ( originalArray[0].A2_XTPFORN !== 'N' && originalArray[0].A2_MEDIA >= nMediaHomologado ))
					let lFinalizado = true

					setHomologado(lFornecedorHomologado)

					if (!lFornecedorHomologado){
						const url = window.location.pathname.replace('Cotacoes','Homologacao')
						
						window.location.href = window.location.origin + url;
						return
					}
					
					setEmpresaFilialSelect(
						{value: retConsulta.data[0].EMPRESA + retConsulta.data[0].C8_FILIAL, text : `${retConsulta.data[0].EMPRESA + retConsulta.data[0].C8_FILIAL} - ${retConsulta.data[0].M0_FILIAL}`}
					)
	
					setCampoAnexosCotacao( JSON.parse( ( retConsulta.data[0].C8_XANXCOT.trim() || '[]') ) )
					setEmpresaFilial(retConsulta.data[0].EMPRESA + retConsulta.data[0].C8_FILIAL)

					setEmpresa({
						M0_FILIAL : originalArray[0].M0_FILIAL,
						M0_CGC : originalArray[0].M0_CGC,
						M0_CEPENT : originalArray[0].M0_CEPENT,
						M0_ENDENT : originalArray[0].M0_ENDENT,
						M0_BAIRENT : originalArray[0].M0_BAIRENT,
						M0_CIDENT : originalArray[0].M0_CIDENT,
						M0_ESTENT : originalArray[0].M0_ESTENT
					})
					
					let dataHoraString = `${originalArray[0].C8_VALIDA} ${originalArray[0].C8_XVALIDA}`
					
					// Converter para um objeto Date (formato YYYY-MM-DDTHH:MM:SS)
					let dataHora = new Date(dataHoraString.substring(0, 4), dataHoraString.substring(4, 6) - 1, dataHoraString.substring(6, 8), dataHoraString.substring(9, 11), dataHoraString.substring(12, 14));

					// Obter a data e hora atual
					let dataAtual = new Date();

					// Comparar as datas
					if (!CotacaoTela && dataHora < dataAtual) {
						habilitaDigitacao = false;
						setExpiradoData(true)						
					}

					const produtosAux = originalArray.reduce((acc, item, index) => {
						// Identificador único para agrupamento
						const groupKey = `${item.C8_ITEM}${item.C1_NUM}${item.C1_ITEM}`;
					
						// Verifica se o grupo já existe no resultado
						let produto = acc.find(p => p.key === groupKey);
						let dataPrevisao = converteDataProtheus(item.C1_DATPRF);
						let dataAprovacao = item.C1_XDTAPRV.trim() ? converteDataProtheus(item.C1_XDTAPRV) : dataPrevisao;
						let dataEmissao = converteDataProtheus(item.C1_EMISSAO);
						let dataEntrega = converteDataProtheus(item.C8_XDTENT);
						let dataValidade = converteDataProtheus(item.C8_XDVFOR);
						let diasDif = item.C1_XDTAPRV.trim() ? calcularDiferencaEmDias(dataEmissao, dataPrevisao) : 0;
						let lAdicionaProduto = true
						let anexoDaProposta = item.C8_XANXMAP.trim() || "[]"

						if (diasDif > 0){
							dataAprovacao = parse(dataAprovacao, 'yyyy-MM-dd', new Date())
							dataAprovacao.setDate(dataAprovacao.getDate() + diasDif);
							dataAprovacao = format(dataAprovacao, 'yyyy-MM-dd');
						}																	

						if (!produto) {
							const cAnexoItem = item.C1_XANEXO.trim() || '[]';
							const habilitaItem = ( item.C8_NUMPED.trim() !== '' || item.C8_NUMCON.trim() !== '' ? false : true )
							const cPeriodo = item.C1_XPERIO === 'D' ? 'Dias ' : item.C1_XPERIO === 'M' ? 'Meses ' : item.C1_XPERIO === 'A' ? 'Anos ' : ''

							if (!CotacaoTela && habilitaDigitacao){
								habilitaDigitacao = habilitaItem
								lAdicionaProduto = habilitaItem
							}
							
							if (lFinalizado && habilitaItem){
								lFinalizado = false
							}

							if (lAdicionaProduto){
								// Adiciona um novo grupo
								produto = {
									cotacao: dadosCotacao.Numero,
									codigo: item.C1_PRODUTO.trim(),
									item: item.C8_ITEM,
									itemId: item.C8_IDENT,
									numSC: item.C8_NUMSC,
									itemSC: item.C8_ITEMSC,
									nome: item.DESCRI.trim(),
									descricaoComplementar: item.C1_OBS,
									certificado: item.C1_XCA,
									periodo: cPeriodo, 
									tempo: item.C1_XLOC,
									quantidade: formatarMoeda2(parseFloat(item.C8_QUANT),4), // Ajuste para quantidade, se aplicável
									unidade: item.C8_UM,
									centroCusto: item.C1_CC.trim() + ' - ' + item.CTT_DESC01,
									dataPrevisao: dataAprovacao,
									fornecedores: [],
									anexoProduto: JSON.parse(cAnexoItem),
									habilitaSelecionar: habilitaItem,
									comprador: item.Y1_NOME,
									emissao: item.C8_EMISSAO,
									key: groupKey // Usado para evitar duplicidade
								};

								acc.push(produto);
							}
						}
					
						if (lAdicionaProduto){
							let nValorFrete = parseFloat((item.C8_VALFRE || 0 ))
							let nValor = parseFloat((item.C8_PRECO || 0 ))
							let nValorICMS = parseFloat((item.C8_VALICM || 0 ))
							let nValorIPI = parseFloat((item.C8_VALIPI || 0 ))
							let nValorICMSST = parseFloat((item.C8_XICMST || 0 ))
							let nValorDIFAL = parseFloat((item.C8_XDIFAL || 0 ))
							let nValorISS = parseFloat((item.C8_XISS || 0 ))
							let nValorTotal = ( nValor * parseFloat(item.C8_QUANT) ) + nValorICMS + nValorIPI + nValorICMSST + nValorDIFAL + nValorISS;
							// Adiciona o fornecedor ao grupo existente

							if (!CotacaoTela){
								handleToggleExpand(item.A2_CGC)
							}
							
							produto.fornecedores.push({
								numeroPedido: item.C8_NUMPED,							
								numeroContrato: item.C8_NUMCON,
								dataLimite: converteDataProtheus(item.C8_VALIDA), 
								horaLimite: item.C8_XVALIDA,
								selecionado: (item.C8_OK === 'OK' || (item.C8_NUMPED.trim() !== ''  && item.C8_NUMPED.trim() !== 'XXXXXX' ) || (item.C8_NUMCON.trim() !== ''  && item.C8_NUMCON.trim() !== 'XXXXXXXXXXXXXXX' )) ? true : false,
								selecionadoFornecedor: false,
								nome: item.C8_FORNOME.trim(),
								cnpj: item.A2_CGC,
								condPadrao: item.A2_COND + ' - ' + item.COND_A2,
								preco: nValor,
								valor: formatarMoeda2(nValor,4),
								valorICMS: formatarMoeda2(nValorICMS,2),
								valorIPI: formatarMoeda2(nValorIPI,2),
								valorICMSST: formatarMoeda2(nValorICMSST,2),
								valorDIFAL: formatarMoeda2(nValorDIFAL,2),
								valorISS: formatarMoeda2(nValorISS,2),
								total: formatarMoeda2(nValorTotal,2),
								CA: item.C8_XCA,
								valorTotal: formatarComoMoeda(nValorTotal,2),
								ultimoPreco:  parseLocaleNumber(item.ULTPRC) || 0,
								ultimoPrecoGeral:  parseLocaleNumber(item.ULTPRCGRL) || 0,
								dataEntrega: dataEntrega,
								observacaoItem: (item.C8_XOBS || '').trim(),
								condicaoPagamento: {value: item.C8_COND.trim() || '', label: item.C8_COND.trim() ? item.C8_COND + ' - ' + item.E4_DESCRI : 'Digite para Localizar'},
								dataValidade: dataValidade,
								observacaoCotacao: (item.C8_XOBSCOT || '').trim(),
								observacaoFornecedor: (item.C8_XOFOR || '').trim(),
								observacaoMapa: (item.C8_OBS || '').trim(),
								justificativa: (item.C8_XJUST || '').trim(),
								totalFornecedor: formatarComoMoeda(0, 2),
								totalSelecionado: formatarComoMoeda(0, 2),
								totalFrete: formatarComoMoeda(nValorFrete, 2),
								enderecoFrete: item.C1_XENDENT,
								frete: formatarMoeda2(nValorFrete,2),
								tipoFrete: {value: item.C8_TPFRETE, text: (item.C8_TPFRETE === 'C' ?  "CIF" : item.C8_TPFRETE === 'F' ? 'FOB' : '')},
								chaveFornecedor: item.C8_FORNECE + '' + item.C8_LOJA,
								chaveSC8: item.C8_FILIAL + item.C8_NUM + item.C8_FORNECE + item.C8_LOJA + item.C8_ITEM,
								anexoMapa: item.C8_XANXMAP.trim() || "[]",
								habilitadoDigitar: habilitaDigitacao,
								habilitadoCamposExtras: habilitaDigitacao,
								respondido: item.C8_XMPRESP === 'S',
								usuario: (CotacaoTela ? 'NPE - Comprador: ' + usuarioProtheus.label : 'Fornecedor - Contato: ' + dadosCotacao.Contato),
								isMenorPreco: false
							});
						}

						setAnexoProposta(JSON.parse(anexoDaProposta))

						return acc;
					}, []);
					
					// const resultado = produtosAux.map(({ key, ...rest }) => rest);
					const newDataTotal = atualizarFornecedoresComTotais(produtosAux);
					atualizaOptionComFornecedores(produtosAux)

					setFinalizado(lFinalizado)
					setProdutos(newDataTotal)

					if (lFinalizado){
						setCampoExibeMapa([{value: 'Todos', text: 'Todos'}])
					}
				}else{
					setCotacaoExcluida(true);
				}
            }
			setCarregar(false)
        }

        fetchData()
    }, []);

	const handleToggleExpand = (fornecedorCNPJ) => {
		const key = `${fornecedorCNPJ}`;
		setExpanded(prev => ({
			...prev,
			[key]: !prev[key],
		}));
	};

	const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

	const atualizaOptionComFornecedores = (produtos) => {
		let optionsSelecaoAux = [...optionsSelecao]
		
		// Primeiro, criamos um mapa para somar os valores de cada fornecedor
		produtos[0].fornecedores.map((fornecedor) => {
			const respondeu = fornecedor.respondido ? '' : '(Não Respondido)'
			optionsSelecaoAux.push({
				value: fornecedor.chaveFornecedor,
				text: fornecedor.nome.trim() + ' - ' + fornecedor.cnpj + respondeu,
			})
		});

		setOptionsSelecao(optionsSelecaoAux)
	}

	const atualizarFornecedoresComTotais = (produtos, calculaFrete = false) => {
		let totaisFrete = []
		// Primeiro, criamos um mapa para somar os valores de cada fornecedor
		const totaisPorFornecedor = produtos.reduce((acumulador, produto) => {
			produto.fornecedores.forEach(({ cnpj, total }) => {
				if (!acumulador[cnpj]) {
					acumulador[cnpj] = 0;
				}
				acumulador[cnpj] += parseLocaleNumber(total);
			});
			return acumulador;
		}, {});
		
		const totaisSelecionado = produtos.reduce((acumulador, produto) => {
			produto.fornecedores.forEach(({ cnpj, selecionado, total }) => {
				if (!acumulador[cnpj]) {
					acumulador[cnpj] = 0;
				}
				acumulador[cnpj] += ( selecionado ? parseLocaleNumber(total) : 0 );
			});
			return acumulador;
		}, {});

		// Depois, atualizamos os fornecedores com o total de cada fornecedor
		produtos.forEach((produto) => {
			produto.fornecedores.forEach((fornecedorObj) => {
				fornecedorObj.totalFornecedor = formatarComoMoeda(totaisPorFornecedor[fornecedorObj.cnpj] + parseLocaleNumber(fornecedorObj.frete),2) ;
				fornecedorObj.totalSelecionado = formatarComoMoeda(totaisSelecionado[fornecedorObj.cnpj] + ( totaisSelecionado[fornecedorObj.cnpj] > 0 ? parseLocaleNumber(fornecedorObj.frete) : 0 ),2) ;
			});
		});

		const produtosAux = handleMenorPrecoMultiplo(produtos);
	  
		return produtosAux; // Retorna os produtos atualizados
	};
	  
	const handleChangeDataFornecedor = (item, data, setData, indexProduto, modifyProduto = true, tipoFrete, valorFrete) => {
		const newData = data.map( (itemProduto, index) => { 
			if (index === indexProduto && modifyProduto ){
				itemProduto.fornecedores.map( (itemData) =>{
					if ( itemData.chaveSC8 === item.chaveSC8 ){
						const total = (parseLocaleNumber(item.valor) * parseLocaleNumber(itemProduto.quantidade)) + 
									parseLocaleNumber(item.valorICMS) + parseLocaleNumber(item.valorIPI) + 
									parseLocaleNumber(item.valorICMSST) + parseLocaleNumber(item.valorDIFAL) + 
									parseLocaleNumber(item.valorISS);
						const totalFrete = total + (itemData.tipoFrete.value === 'F' ? parseLocaleNumber(item.frete) : 0)
						const valorTotalFormat = formatarComoMoeda(total, 2);

						itemData.selecionado 	= item.selecionado;
						itemData.frete 			= (itemData.tipoFrete?.value === 'F' ? item.frete: formatarMoeda2(0,2));
						itemData.preco 			= parseFloat(parseLocaleNumber(item.valor),4);
						itemData.valor 			= formatarMoeda2(item.valor,4);
						itemData.valorICMS 		= formatarMoeda2(item.valorICMS,2);
						itemData.valorIPI 		= formatarMoeda2(item.valorIPI,2);
						itemData.valorICMSST 	= formatarMoeda2(item.valorICMSST,2);
						itemData.valorDIFAL 	= formatarMoeda2(item.valorDIFAL,2);
						itemData.valorISS 		= formatarMoeda2(item.valorISS,2);
						itemData.total		 	= formatarMoeda2(total,2);
						itemData.CA				= item.CA;
						itemData.valorTotal 	= valorTotalFormat;
						itemData.dataEntrega	= item.dataEntrega;
						itemData.observacaoItem	= item.observacaoItem;
					}
				})
			}else if (!modifyProduto){
				itemProduto.fornecedores.map( (itemData) =>{
					if (itemData.chaveFornecedor === item.chaveFornecedor){
						if (tipoFrete){
							if (tipoFrete?.value !== itemData.tipoFrete?.value){
								const total = (parseLocaleNumber(itemData.valor) * parseLocaleNumber(itemProduto.quantidade)) + 
											 parseLocaleNumber(itemData.valorICMS) + parseLocaleNumber(itemData.valorIPI) + 
											 parseLocaleNumber(itemData.valorICMSST) + parseLocaleNumber(itemData.valorDIFAL) + 
											 parseLocaleNumber(itemData.valorISS);

								const valorTotalFormat = formatarMoeda2(total, 2);
								
								itemData.frete = formatarMoeda2(0,2);
								itemData.total = valorTotalFormat;
							};

							itemData.tipoFrete = tipoFrete;
						}else if(valorFrete){
							itemData.frete = formatarMoeda2(parseLocaleNumber(valorFrete),2);
						}

						itemData.condicaoPagamento		= item.condicaoPagamento;
						itemData.dataValidade			= item.dataValidade;
						itemData.observacaoFornecedor	= item.observacaoFornecedor;
						itemData.observacaoMapa			= item.observacaoMapa;
						itemData.justificativa			= item.justificativa;
					}
				})
			}
			
			return itemProduto
		} )

		//Somar Valor Total por Fornecedor
		const newDataTotal = atualizarFornecedoresComTotais(newData);

		setData(newDataTotal)
	}

	const handleChangeTipoFrete = (valor, produtos, setProdutos, indexFornecedor = 0) => {
		handleChangeDataFornecedor(produtos[0].fornecedores[indexFornecedor], produtos, setProdutos, 0, false, valor)		
	}

	const handleChangeSelecionado = (valor, item, data, setData, indexProduto) => {
		handleChangeDataFornecedor(item, data, setData, indexProduto)

		if (valor){
			const newData = data.map( (itemProduto, index) => { 
				if (index === indexProduto ){
					itemProduto.fornecedores.map( (itemData) =>{
						itemData.selecionado = (itemData.chaveSC8 === item.chaveSC8);
					})
				}
				return itemProduto
			} )

			//Somar Valor Total por Fornecedor
			const newDataTotal = atualizarFornecedoresComTotais(newData);

			setData(newDataTotal)
		}
	}

	const btnIncluirDesmembramento = () => {
		const newId = Date.now()
		const idEntidade = chaveItemCotacao.split('|')[0]
		const qtdSC = parseFloat(chaveItemCotacao.split('|')[3])
		const newQTD = parseFloat(quantidadeDesmembrar || '0')
		const qtdInc = parseFloat($(`#SALDOSC`)[0].value);
		
		if (newQTD > 0){
			if (qtdInc + newQTD > qtdSC){
				toast.warn('Quantidade Superior ao Permitido!!')
			}else{
				setDataDesmembramento((prevData) => [...prevData, { 
					Id: newId, 
					NUMERO: numeroCotacao, 
					IDENT: idEntidade, 
					NOVAQTD: newQTD, 
					deletado: false 
				},]);
	
				$(`#QTDDESM`)[0].value = 0;
				quantidadeDesmembrar = 0;
			}
		}		
	}

	useEffect( () => {
		// Garante que existe um container no DOM
		const container = document.getElementById("tableQuantidade");

		if (container) {
			const root = ReactDOM.createRoot(container);
			root.render(
				<ResponsiveDataTable 
					habilitaBuscar={false}  
					columns={[{ Header: 'Nova Quantidade',          accessor: 'NOVAQTD'}]}
					data={dataDesmembramento.filter((item) => item.deletado === false)} 
					isIgnorar={true}
					buttons={[
						{ action: handleExcluirDesmembramento, label: "Excluir", icone: "MdPlaylistRemove", style: "danger" }
					]}
				/>
			);

			let quantidadeDesmembrada = 0;
			dataDesmembramento.forEach((item) => {
				if (item.deletado === false){
					quantidadeDesmembrada += item.NOVAQTD
				}
			})

			dadosDesmembrados = [...dataDesmembramento];

			$(`#SALDOSC`)[0].value = quantidadeDesmembrada;
		}
	}, [dataDesmembramento] )

	const handleExcluirDesmembramento = (row) => {
        const id = row.original.Id;
        
        setDataDesmembramento((prevData) => 
            prevData.map((item) => {
                if (item.Id === id){
                    return { ...item, deletado: true };
                }else{
                    return item;
                } 
            })
        );      
	}

	const handleDesmembraItem = async(idEntidade, sc, item, qtde, produto) => {
		setDataDesmembramento([]);
		dadosDesmembrados = [];

		const quantidade = parseLocaleNumber(qtde)
		chaveItemCotacao = idEntidade + '|' + sc + '|' + item + '|' + quantidade;
		const Titulo = (<>Desmembrar Item da Cotação - SC: {sc} / Item: {item} <br/> Produto: {produto}</>)
		const Mensagem = <>
			<Row>
				<Col md="3" xs="12">
					<FormLabel>Quantidade Originial</FormLabel>
					<FormControl
						id={'QTDESC'}
						type='number'
						value={quantidade}
						disabled={true}
					/>						
				</Col>
				<Col md="3" xs="12">
					<FormLabel>Quantidade a Desmembrar</FormLabel>
					<FormControl
						id={'QTDDESM'}
						type='number'
						step={0.01}
						onChange={(e) => quantidadeDesmembrar = e.target.value}
					/>						
				</Col>
				<Col md="3" xs="12"></Col>
				<Col md="3" xs="12" className="d-flex align-content-end align-items-end justify-content-end">
					<Button variant="primary" style={{width: '100%'}} onClick={btnIncluirDesmembramento}>
						✚ Adicionar
					</Button>							
				</Col>				
			</Row>
			<div id="tableQuantidade"></div>
			<Row>
				<Col md="3" xs="12">
					<FormLabel>Quantidade Desmembrada</FormLabel>
					<FormControl
						id={'SALDOSC'}
						type='number'
						value={0}
						disabled={true}
					/>						
				</Col>
				<Col md="6" xs="12"></Col>
				<Col md="3" xs="12" className="d-flex align-content-end align-items-end justify-content-end">
					<Button variant="danger" style={{width: '100%'}} onClick={FechaBootBox}>
						✗ Cancelar
					</Button>		
					&nbsp;
					<Button variant="success" style={{width: '100%'}} onClick={handleDesmembrar}>
						✓ Confirmar
					</Button>							
				</Col>
			</Row>
		</>

		DisparaBootBox(Titulo, Mensagem, [], 0, FechaBootBox, 'xl', false);
	}

	const handleDesmembrar = async() => {
		const qtdSC = parseFloat($(`#QTDESC`)[0].value);
		const qtdInc = parseFloat($(`#SALDOSC`)[0].value);
		if (qtdInc < qtdSC){
			toast.warn("Existe Quantidade ainda a ser Desmembrada")
			return
		}

		const objSalvar = dadosDesmembrados
			.filter((item) => item.deletado === false)
			.map((item) => { return { 
					NUMERO: item.NUMERO,
					IDENT: item.IDENT,
					NOVAQTD: item.NOVAQTD
				}
			})
		
		const jsonSalvar = JSON.stringify( objSalvar )
		let oRetorno

		oRetorno = await ConsumoTOTVS_POST('DESMEMBRARCOTACAO', jsonSalvar, empresaFilial)
		
		setCarregar(false)

		if (oRetorno.error === '00'){
			SucessoMsg("Dados Gravados com Sucesso!!!")
			window.location.reload();
		}else{
			ErroMsg(oRetorno.description)
		}
		
		FechaBootBox()
	}

	const handleHistorico = async(produto, fornecedor) => {
		let dataProdutos = [];
		let codigoProduto = produto.codigo;
		let codigoFornecedor = (fornecedor ? fornecedor.chaveFornecedor.substr(-10).substr(0,6) : '');
		let lojaFornecedor = (fornecedor ? fornecedor.chaveFornecedor.substr(-4) : '');

		let consulta = "SELECT TOP 100 B1_COD, B1_DESC, C7_CC, CTT_DESC01, C7_FILIAL, C7_NUM, C7_QUANT, C7_PRECO, C7_TOTAL, C7_EMISSAO, A2_COD + ' - ' + A2_LOJA FORNECE, A2_NOME "
		consulta += "FROM TABELA(SC7) SC7 "
		consulta += "INNER JOIN TABELA(SB1) SB1 ON B1_FILIAL = FILIAL(SB1) AND B1_COD = C7_PRODUTO AND SB1.D_E_L_E_T_ <> '*' "
		consulta += "INNER JOIN TABELA(SA2) SA2 ON A2_FILIAL = FILIAL(SA2) AND A2_COD = C7_FORNECE AND A2_LOJA = C7_LOJA AND SA2.D_E_L_E_T_ <> '*' "
		consulta += "INNER JOIN TABELA(CTT) CTT ON CTT_FILIAL = FILIAL(CTT) AND CTT_CUSTO = C7_CC AND CTT.D_E_L_E_T_ <> '*' "
		consulta += "WHERE SC7.D_E_L_E_T_ <> '*' "
	    
		if (codigoFornecedor && lojaFornecedor){
			consulta += "AND C7_FORNECE = '" + codigoFornecedor + "' AND C7_LOJA = '" + lojaFornecedor + "' "
		}
		consulta += "AND C7_PRODUTO = '" + codigoProduto + "' "
		consulta += "ORDER BY C7_EMISSAO DESC "

        const retConsulta = await ConsultaTotvsEmpresa(consulta, 'SB1;SC7;SA2;CTT', empresaFilial)
        
        if (retConsulta.data){
            if (retConsulta.data.length > 0){
                dataProdutos = retConsulta.data;
				
				UltimasCompras( DisparaBootBox, FechaBootBox, dataProdutos);
            }else{
				toast.info('Não há dados de Compras Anteriores desse Produto')
			}
        }

	}
	
	const handleHistoricoItem = async(chaveHistorico) => {
		let dataCotacao = [];
		let consulta = "SELECT IIF(C8_TPFRETE = 'F', 'FOB', 'CIF') TPFRETE, E4_DESCRI, CASE WHEN B5_CEME != '' THEN B5_CEME ELSE B1_DESC END AS B1_DESC, "
		consulta += " C8_VALFRE, C8_PRECO, C8_VALICM, C8_VALIPI, C8_XICMST, C8_XDIFAL, C8_XISS, C8_TOTAL, C8_XDTENT, C8_XDVFOR, C8_XUSRESP, C8_PRODUTO, C8_NUMPRO, "
		consulta += " C8_FORNECE, C8_LOJA, C8_FORNOME, C8_ITEM "
		consulta += "FROM TABELA(SC8) SC8 "
		consulta += "INNER JOIN TABELA(SB1) SB1 ON B1_FILIAL = FILIAL(SB1) AND B1_COD = C8_PRODUTO AND SB1.D_E_L_E_T_ <> '*' "
		consulta += "INNER JOIN TABELA(SE4) SE4 ON E4_FILIAL = FILIAL(SE4) AND E4_CODIGO = C8_COND AND SE4.D_E_L_E_T_ <> '*' "
		consulta += "LEFT JOIN TABELA(SB5) SB5 ON B5_COD = C8_PRODUTO AND SB5.D_E_L_E_T_ <> '*' "
		consulta += "WHERE C8_FILIAL + C8_NUM + C8_FORNECE + C8_LOJA + C8_ITEM = '" + chaveHistorico + "' "
		consulta += "AND ( ( C8_NUMPRO = '01' AND SC8.D_E_L_E_T_ <> '*' ) OR (C8_NUMPRO <> '01' AND SC8.D_E_L_E_T_ = '*') )"
		consulta += "ORDER BY IIF(C8_NUMPRO = '01', 'ZZ', C8_NUMPRO) DESC "

        const retConsulta = await ConsultaTotvsEmpresa(consulta, 'SC8;SB1;SB5;SE4', empresaFilial)
        
        if (retConsulta.data){
            if (retConsulta.data.length > 0){
                dataCotacao = retConsulta.data;
		
				const columns = [
					{ Header: 'Cond. Pagto',    accessor: 'E4_DESCRI'},
					{ Header: 'Tipo Frete',     accessor: 'TPFRETE'},
					{ Header: 'Frete',          accessor: 'C8_VALFRE', Cell: handleValorTotal },
					{ Header: 'Preço',          accessor: 'C8_PRECO', Cell: (item) => {return formatarComoMoeda(item.value,4)}},
					{ Header: 'Imposto',        accessor: 'C8_VALICM', Cell: (item) => {
						const {C8_VALICM, C8_VALIPI, C8_XICMST, C8_XDIFAL, C8_XISS} = item.row.original
						return ( <>
								{C8_VALICM > 0 && (<><strong>ICMS: </strong>{formatarComoMoeda(C8_VALICM)}<br/></> ) }
								{C8_VALIPI > 0 && (<><strong>IPI: </strong>{formatarComoMoeda(C8_VALIPI)}<br/></> ) }
								{C8_XICMST > 0 && (<><strong>ICMS-ST: </strong>{formatarComoMoeda(C8_XICMST)}<br/></> ) }
								{C8_XDIFAL > 0 && (<><strong>DIFAL: </strong>{formatarComoMoeda(C8_XDIFAL)}<br/></> ) }
								{C8_XISS > 0 && (<><strong>ISS: </strong>{formatarComoMoeda(C8_XISS)}</> ) }
							</> )
					}},
					// { Header: 'ICMS',          	accessor: 'C8_VALICM'},
					// { Header: 'IPI',          	accessor: 'C8_VALIPI'},
					// { Header: 'ICMS - ST',      accessor: 'C8_XICMST'},
					// { Header: 'DIFAL',          accessor: 'C8_XDIFAL'},
					// { Header: 'ISS',          	accessor: 'C8_XISS'},
					{ Header: 'Total',    		accessor: 'C8_TOTAL', Cell: handleValorTotal},
					{ Header: 'Data Entrega',   accessor: 'C8_XDTENT', Cell: handleData},
					{ Header: 'Data Validade',  accessor: 'C8_XDVFOR', Cell: handleData},
					{ Header: 'Usuário',  		accessor: 'C8_XUSRESP'}
				];

				const Fornecedor = dataCotacao[0].C8_FORNECE + '/' + dataCotacao[0].C8_LOJA + ' - ' + dataCotacao[0].C8_FORNOME
				const Produto = dataCotacao[0].C8_PRODUTO + ' - ' + dataCotacao[0].B1_DESC
				const Titulo = (
					<>
						<p>Histórico da Cotação </p>
						<p>Fornecedor: {Fornecedor}</p>
						<p>Item: {dataCotacao[0].C8_ITEM} - Produto: {Produto}</p>
					</> );

				const Mensagem = (
					<ResponsiveDataTable
						columns={columns}
						data={dataCotacao} // Carregar dados conforme necessário
						buttons={[]}
						isIgnorar={true}
						linhaCondicional={(item) => item.C8_NUMPRO === '01'}
						corCondicional='#359a53'
					/>
				);

				const buttonsRender = [
					{ variant: 'primary', action: FechaBootBox, label: 'Fechar' }
				];

				DisparaBootBox(Titulo, Mensagem, buttonsRender, 0, FechaBootBox, 'xl', false);
			}
        }
	}

	const handleObservacao = (observacao) => {
		const Mensagem = (
			<InputGeral
				tipo="textArea"
				value={observacao}
				disabled={true}
			/>
		);
	
		const buttonsRender = [
			{ variant: 'primary', action: FechaBootBox, label: 'Fechar' }
		];
	
		DisparaBootBox('Observação Item', Mensagem, buttonsRender, 0, FechaBootBox, 'xl', false);
	}

	const handleHabilitaDigitar = (chaveFornecedor, anexos) => {
		if (CotacaoTela){
			let lDisable = false
			chaveAnexos = chaveFornecedor
			try{
				campoAnexos = JSON.parse(anexos)
			}catch(error){
				campoAnexos = JSON.parse('[]')
			}

			lDisable = !( analisaFornecedor(chaveFornecedor, [], null, true) )

			const Mensagem = (
				<Row>
					<Col md="12" xs="12">
						<LabelInput>Anexos</LabelInput>
						<UploadFiles 
							onDropEvent={handleAddFiles}
							value={campoAnexos}
							disabled={lDisable}
							disabledDelete={true}
						/>
					</Col>
				</Row>
			);
		
			const buttonsRender = [
				{ variant: 'primary', action: FechaHabilitaAnexos, label: 'Fechar' }
			];
		
			DisparaBootBox('Adicione em Anexo o E-mail enviado pelo Fornecedor', Mensagem, buttonsRender, 0, FechaHabilitaAnexos, 'xl', false);
		}
	}

	const analisaFornecedorHabilitado = (chaveFornecedor, data) => {
		var lHabilita = false
		data.some((produto) => {
			return produto.fornecedores.some((fornecedor) => {
				if (fornecedor.chaveFornecedor === chaveFornecedor) {
					// Verifica se habilitaDigitar é true
					lHabilita = true;
					return fornecedor.habilitaDigitar === true;
				}
				return false;
			});
		});

		const newData = data.map( (itemProduto, index) => { 
			itemProduto.fornecedores.map( (itemData) =>{
				if (itemData.chaveFornecedor === chaveFornecedor){
					itemData.habilitadoCamposExtras = lHabilita
				}
			})
			return itemProduto
		})


		return newData
	};

	const analisaFornecedor = (chaveFornecedor, arrayAnexo, stringAnexo, lCabecalho) => {
		return produtos.some((produto) => {
			return produto.fornecedores.some((fornecedor) => {
				if (fornecedor.chaveFornecedor === chaveFornecedor) {
					// Verifica as condições
					const camposVazios = !fornecedor.numeroContrato.trim() && !fornecedor.numeroPedido.trim();
					const habilitaAnexo = (lCabecalho ? true : arrayAnexo.length > 0 && stringAnexo.trim() !== fornecedor.anexoMapa);
					const habilitaDigitar = camposVazios && habilitaAnexo;
	
					// Retorna verdadeiro se o fornecedor puder ser preenchido
					return habilitaDigitar;
				}
				return false;
			});
		});
	};
	
	const FechaHabilitaAnexos = () => {
		const anexoSalvar = JSON.stringify(campoAnexos)
		const habilitaFornecedor = analisaFornecedor(chaveAnexos, campoAnexos, anexoSalvar)
		
        const newData = produtos.map( (itemProduto) => { 
			itemProduto.fornecedores.map( (itemData) =>{
				const habilitaCampos = !itemData.numeroContrato.trim() && !itemData.numeroPedido.trim()
				const habilitaAnexo = ( campoAnexos.length > 0 && anexoSalvar.trim() !== itemData.anexoMapa ? true : false )
				const habilitaDigitarValor = ( habilitaCampos ? habilitaAnexo : false )
				
				if (itemData.chaveFornecedor === chaveAnexos){
					itemData.habilitadoDigitar = habilitaDigitarValor
					itemData.anexoMapa = anexoSalvar
				}
			})
			
			return itemProduto
		} )

		const newDataExtra = analisaFornecedorHabilitado(chaveAnexos, newData)
		chaveAnexos = ""
		campoAnexos = "[]"

		setProdutos(newDataExtra)
        FechaBootBox()
    }

	const handleAddFiles = async(acceptedFiles, fileRejections, event) => {
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];
        const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

        if (!isValidFileType) {
            toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC ou arquivos de texto.');
            return;
        }

        const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
        
        if (event){
            event.persist()
            event.preventDefault()
        }

        if (retUpload.error === "00") {
            const newFiles = retUpload.data.map(file => file);
            const filesUpload = [...campoAnexos, ...newFiles]
            campoAnexos = filesUpload

            return filesUpload;
        }
    }
	
  	const handleDelFilesProposta = (fileDelete) => {
        const updatedFiles = [...anexoProposta];
        updatedFiles.splice(fileDelete, 1);
        
        setAnexoProposta(updatedFiles)

		//Atualiza o Array preenchendo o Anexo
		const anexoSalvar = JSON.stringify(updatedFiles)
		
		const newData = produtos.map( (itemProduto) => { 
			itemProduto.fornecedores.map( (itemData) =>{
				itemData.anexoMapa = anexoSalvar
			})
			
			return itemProduto
		} )

		setProdutos(newData);

        return updatedFiles;
    }

	const handleAddFilesProposta = async(acceptedFiles, fileRejections, event) => {
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];
        const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

        if (!isValidFileType) {
            toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC ou arquivos de texto.');
            return;
        }

        const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
        
        if (event){
            event.persist()
            event.preventDefault()
        }

        if (retUpload.error === "00") {
            const newFiles = retUpload.data.map(file => file);
            const filesUpload = [...anexoProposta, ...newFiles]
            
			setAnexoProposta(filesUpload)
			//Atualiza o Array preenchendo o Anexo
			const anexoSalvar = JSON.stringify(filesUpload)
			
			const newData = produtos.map( (itemProduto) => { 
				itemProduto.fornecedores.map( (itemData) =>{
					itemData.anexoMapa = anexoSalvar
				})
				
				return itemProduto
			} )

			setProdutos(newData);

            return filesUpload;
        }
    }

	const showAnexoItem = (anexos) => {
		try{
			campoAnexos = anexos
		}catch(error){
			campoAnexos = JSON.parse('[]')
		}

		const Mensagem = (
			<Row>
				<Col md="12" xs="12">
					<LabelInput>Anexos</LabelInput>
					<UploadFiles 
						value={campoAnexos}
						disabled={true}
						disabledDelete={true}
					/>
				</Col>
			</Row>
		);
	
		const buttonsRender = [
			{ variant: 'primary', action: FechaBootBox, label: 'Fechar' }
		];
	
		DisparaBootBox('Anexo do item', Mensagem, buttonsRender, 0, FechaBootBox, 'xl', false);
	}

	const handleSalvar = async(lValida = false) => {
		const msgErro = validarPrecoSemDataEntrega()
		if (msgErro !== ''){
			const Mensagem = <div dangerouslySetInnerHTML={{ __html: convertSpecialCharsToHtml(msgErro || "") }} />
			const buttonsRender = [
				{ variant: 'primary', action: FechaBootBox, label: 'Fechar' }
			];
					
			DisparaBootBox('Inconsistência nos Itens', Mensagem, buttonsRender, 0, FechaBootBox, 'xl', false);
			
			return false;
		}else{
			let statusSave = false		
			let mapaPDF
			let produtosAux
			
			if (!CotacaoTela && anexoProposta){
				mapaPDF = await MapaCotacaoPDF(produtos, empresaFilial, CotacaoTela, campoExibeMapa)

				const file = new File([mapaPDF], 'Proposta.pdf', { type: 'application/pdf' });
				
				const retUpload = await ConsumoAPI_FileUpload([file]);

				if (retUpload.error === "00") {
					const newFiles = retUpload.data.map(file => file);
					const filesUpload = [...anexoProposta, ...newFiles]
					
					setAnexoProposta(filesUpload)
					
					//Atualiza o Array preenchendo o Anexo
					const anexoSalvar = JSON.stringify(filesUpload)
					
					produtosAux = produtos.map( (itemProduto) => { 
						itemProduto.fornecedores.map( (itemData) =>{
							itemData.anexoMapa = anexoSalvar
						})
						
						return itemProduto
					} )
				}	
			}

			setCarregar(true)
			const jsonSalvar = JSON.stringify( (produtosAux || produtos) )
			let oRetorno

			oRetorno = await ConsumoTOTVS_POST('PREENCHECOTACAO', jsonSalvar, empresaFilial)
			
			setCarregar(false)

			if (oRetorno.error === '00'){
				SucessoMsg("Dados Gravados com Sucesso!!!")
				statusSave = true

				if (!CotacaoTela && mapaPDF){
					const url = URL.createObjectURL(mapaPDF);
					window.open(url);
				}
			}else{
				ErroMsg(oRetorno.description)
			}

			return lValida ? statusSave : false
		}
	}

	const validarPrecoSemDataEntrega = () => {
		const erros = []; // Armazena os erros encontrados
	
		produtos.forEach((produto, produtoIndex) => {
			if (produto.fornecedores && produto.fornecedores.length > 0) {
				produto.fornecedores.forEach((fornecedor, fornecedorIndex) => {
					// Verifica se o campo 'preco' está preenchido e 'dataEntrega' está vazio
					if ( parseFloat(fornecedor.preco) > 0 && (!fornecedor.dataEntrega || fornecedor.dataEntrega.trim() === "") ) { // Preço preenchido e DataEntrega vazia
						erros.push(`<p><strong>${fornecedor.nome}</strong> - Produto <strong>${produto.nome}</strong> sem Data de Entrega</p>`);
					}
					if ( fornecedor.condicaoPagamento.value.trim() === '' && fornecedor.selecionado === true ) {
						erros.push(`<p><strong>${fornecedor.nome} - Selecionado </strong> sem Condição de Pagamento Informada</p>`);
					}
				});
			}
		});
	
		// Retorna os erros encontrados ou uma mensagem indicando que todos os dados estão válidos
		return erros.length > 0 ? erros.join("") : '';
	};

	const handleMenorPrecoMultiplo = (produtosArray) => {
		let produtosAux = [...produtosArray];

		if (CotacaoTela){
			produtosAux = produtosArray.map((produto) => {
				// Verifica se o produto possui fornecedores e se pode selecionar
				if (produto.fornecedores && produto.fornecedores.length > 0) {
					// Filtra fornecedores com 'total' maior que 0
					const fornecedoresValidos = produto.fornecedores.filter(
						(fornecedor) => parseLocaleNumber(fornecedor.total) > 0
					);

					if (fornecedoresValidos.length > 0) {
						// Encontra o menor preço entre os fornecedores válidos
						const menorPreco = Math.min(
							...fornecedoresValidos.map((f) => parseLocaleNumber(f.total))
						);

						// Atualiza os fornecedores com base no menor preço
						produto.fornecedores = produto.fornecedores.map((fornecedor) => {
							const precoFornecedor = parseLocaleNumber(fornecedor.total);
							const isMenor = precoFornecedor === menorPreco;

							return {
								...fornecedor,
								isMenorPreco: isMenor
							};
						});
					}
				}
				return produto;
			});
		}

		return produtosAux// Atualiza os totais
	};

	const handleChangeSelecionadoAll = (fornecedor, produtos, setProdutos, valor) => {
		const produtosAux = produtos.map((produto) => {
			// Verifica se o produto possui fornecedores
			if (produto.fornecedores && produto.fornecedores.length > 0 && produto.habilitaSelecionar) {
				// Filtra fornecedores com 'total' maior que 0 e com Chave igual ao parametro fornecedor
				const fornecedoresValidos = produto.fornecedores.filter(
					(item) => parseLocaleNumber(item.total) > 0 && item.chaveFornecedor === fornecedor.chaveFornecedor
				);
	
				// Se houver fornecedores válidos, encontra o menor preço
				if (fornecedoresValidos.length > 0) {
					// Atualiza a propriedade 'selecionado' nos fornecedores
					produto.fornecedores = produto.fornecedores.map((fornecedor) => ({
						...fornecedor,
						selecionado: fornecedoresValidos.includes(fornecedor) && valor,
						selecionadoFornecedor: fornecedoresValidos.includes(fornecedor) && valor,
					}));
				}else if(valor){
					produto.fornecedores = produto.fornecedores.map((item) => ({
						...item,
						selecionado: false,
						selecionadoFornecedor: item.chaveFornecedor === fornecedor.chaveFornecedor,
					}));
				}

			}

			return produto;
		});

		//Somar Valor Total por Fornecedor
		const newDataTotal = atualizarFornecedoresComTotais(produtosAux);

		setProdutos(newDataTotal);
	}

	const handleMelhorPreco = () => {
		const produtosAux = produtos.map((produto) => {
			// Verifica se o produto possui fornecedores
			if (produto.fornecedores && produto.fornecedores.length > 0 && produto.habilitaSelecionar) {
				// Filtra fornecedores com 'total' maior que 0
				const fornecedoresValidos = produto.fornecedores.filter(
					(fornecedor) => parseLocaleNumber(fornecedor.total) > 0
				);
	
				// Se houver fornecedores válidos, encontra o menor preço
				if (fornecedoresValidos.length > 0) {
					const menorPrecoFornecedor = fornecedoresValidos.reduce((menor, fornecedor) => {
						return parseLocaleNumber(fornecedor.total) < parseLocaleNumber(menor.total) ? fornecedor : menor;
					});
	
					// Atualiza a propriedade 'selecionado' nos fornecedores
					produto.fornecedores = produto.fornecedores.map((fornecedor) => ({
						...fornecedor,
						isMenorPreco: fornecedor === menorPrecoFornecedor,
						selecionado: fornecedor === menorPrecoFornecedor,
					}));
				}
			}
			return produto;
		});

		//Somar Valor Total por Fornecedor
		const newDataTotal = atualizarFornecedoresComTotais(produtosAux);

		setProdutos(newDataTotal);
	}

	const handleImprimir = async() => {
		const blob = await MapaCotacaoPDF(produtos, empresaFilial, CotacaoTela, campoExibeMapa)
		const url = URL.createObjectURL(blob);
		window.open(url);
	};

	const handleFinalizar = async() => {
		const lProssegue = (await handleSalvar(true))
		let lRetorno = true
		
		if (lProssegue){
			setCarregar(true)
			//Ajustar para gerar a Estrutura de Finalizar, adicionando os Itens que não são marcados para Gerar igual
			//Permitindo atraves do Laço repetir o Encerramento
			const aFornecedores = gerarEstruturaFinalizar()
			
			//Laço para Encerramento de Aglutinação de CC's
			for (const item of aFornecedores.fornecedoresSelecionados) {
				const jsonFinalizar = {
					cotacao: numeroCotacao,
					comprador: usuarioProtheus.value,
					fornecedores: [ item ]
				};

				const jsonSalvar = JSON.stringify(jsonFinalizar);

				let oRetorno = await ConsumoTOTVS_POST('FINALIZACOTACAO', jsonSalvar, empresaFilial);

				if (oRetorno.error === '00') {
					SucessoMsg(oRetorno.description);
				} else {
					ErroMsg(oRetorno.description);
					lRetorno = false;
				}
			}
			//Fim do Laço

			if (!lRetorno){
				return false
			}
			
			setCarregar(false)
		}
	}

	const gerarEstruturaFinalizar = () => {
		const fornecedoresSelecionados = [];

		produtos.forEach(produto => {
			if (produto.habilitaSelecionar) {
				const fornecedorSelecionado = produto.fornecedores.find(fornecedor => fornecedor.selecionado);

				if (fornecedorSelecionado) {
					// Busca por fornecedor com a mesma chave E o mesmo centro de custo
					const fornecedorExistente = fornecedoresSelecionados.find(f => 
						f.fornecedorSelecionado === fornecedorSelecionado.chaveFornecedor &&
						f.centroCusto === produto.centroCusto
					);

					if (fornecedorExistente) {
						// Adiciona novo item e armazena referência do índice
						const novoItemIndex = fornecedorExistente.Itens.push({
							item: produto.item,
							selecionado: fornecedorSelecionado.chaveSC8,
							naoSelecionado: []
						}) - 1;

						produto.fornecedores.forEach(fornecedorAux => {
							if (!fornecedorAux.selecionado) {
								fornecedorExistente.Itens[novoItemIndex].naoSelecionado.push(fornecedorAux.chaveSC8);
							}
						});
					} else {
						const fornecedorNovo = {
							fornecedorSelecionado: fornecedorSelecionado.chaveFornecedor,
							centroCusto: produto.centroCusto,
							Itens: [{
								item: produto.item,
								selecionado: fornecedorSelecionado.chaveSC8,
								naoSelecionado: []
							}]
						};

						produto.fornecedores.forEach(fornecedorAux => {
							if (!fornecedorAux.selecionado) {
								fornecedorNovo.Itens[0].naoSelecionado.push(fornecedorAux.chaveSC8);
							}
						});

						fornecedoresSelecionados.push(fornecedorNovo);
					}
				}
			}
		});

		return {
			fornecedoresSelecionados
		};
	};

	// Mantém o número de colunas do mapa coerente com o filtro de fornecedores.
	const fornecedoresVisiveisMapa = (produtos?.[0]?.fornecedores || []).filter((fornecedor) => {
		const valoresFiltro = campoExibeMapa.map((item) => item.value);
		return campoExibeMapa[0]?.value === 'Todos' ||
			(campoExibeMapa[0]?.value === 'Respondidos' && fornecedor.respondido) ||
			(!/Todos|Respondidos/.test(valoresFiltro.join(';')) && valoresFiltro.join(';').includes(fornecedor.chaveFornecedor));
	});

	return (
		<>
			<Container>
			<LoadingSpinner isLoading={carregar}/>
			{ CotacaoTela && (
				<>
					<Row>
						<Col md="12" xs="12">
							<TitlePageTotvs 
								text={`Mapa Comparativo de Cotação - ${numeroCotacao}`}
								empresa={empresaFilialSelect} 
								empresaFilial={empresaFilial} 
								changeEmpresa={handleEmpresaFilial}
							/>
						</Col>
					</Row>
					<Row>
						<Col md="6" xs="12">
							<SelectFixo 
								options={optionsSelecao}
								isLabel={true} 
								label="Exibe Fornecedores"
								onChange={(e) => { 
									if (e.length === 0) { 
										setCampoExibeMapa([optionsSelecao[1]])
									}else{
										setCampoExibeMapa(e)
									}
								}}
								selectedOptionValue={campoExibeMapa}
								value={campoExibeMapa}
								multiple={true}
								permiteVazio={false}
							/>
						</Col>
						<>
							<Col md="3" xs="12"></Col>
							<Col md="3" xs="12">
						{ !finalizado && 
								<MarginButton variant='primary' className='w-100 h-40' onClick={handleMelhorPreco}>Melhor Preço</MarginButton>
						}
								<Button variant='success' className='w-100 h-40' onClick={handleImprimir}>Imprimir PDF</Button>
							</Col>
						</>
					</Row>
				</>
			)}
			{ !CotacaoTela && !cotacaoExcluida && (
				<Title>{`Mapa de Cotação - Fornecedor`}</Title>
			)}

			{ !CotacaoTela && !homologado && cotacaoExcluida &&
				<div className="container mt-4">
					<h5>Prezado Fornecedor, Identificamos em nosso sistema que este processo de cotação foi <strong>cancelado pelo Comprador.</strong></h5>
					<h5>Agradecemos pelo seu interesse e acesso.!</h5>
				</div>
			}

			{ !CotacaoTela && !homologado && !cotacaoExcluida && 
				<div className="container mt-4">
					<SubTitle>Prezado Fornecedor, identificamos em nosso sistema que você ainda não realizou o processo de Homologação</SubTitle>
					<a href={urlHomologacao} className="text-primary ms-1" >Clique aqui para Acessar!</a>
				</div>
			}

			{ produtos && produtos.length > 0 && !CotacaoTela && (
				<>
					<div className="container mt-4">
						<SubTitle>Dados da Cotação</SubTitle>
						<Row>
							<Col md="4">
								<InputGeral
									label={"Cotação"}
									value={numeroCotacao}
									tipo={"text"}
									disabled={true}
								/>
							</Col>
							<Col md="4">
								<InputGeral
									label={"Data Limite"}
									value={produtos[0].fornecedores[0].dataLimite}
									tipo={"date"}
									disabled={true}
								/>
							</Col>
							<Col md="4">
								<InputGeral
									label={"Hora Limite"}
									value={produtos[0].fornecedores[0].horaLimite}
									tipo={"hora"}
									disabled={true}
								/>
							</Col>
						</Row>
						<Row>
							<Col md="12">
								<InputGeral
									label={"Observação Cotação"}
									bindItem={produtos[0].fornecedores[0]}
									field={"observacaoCotacao"}
									value={produtos[0].fornecedores[0].observacaoCotacao}
									tipo={"textArea"}
									disabled={true}
								/>
							</Col>
						</Row>
					</div>
					{ campoAnexosCotacao && campoAnexosCotacao.length > 0 && (
						<div className="container mt-4">
							<SubTitle>Anexo(s) da Cotação</SubTitle>
							<Row>
								<Col md="12" xs="12">
									<UploadFiles 
										value={campoAnexosCotacao}
										disabled={true}
										disabledDelete={true}
									/>
								</Col>
							</Row>
						</div>
					) }
					<div className="container mt-4">
						<SubTitle>Dados de Faturamento</SubTitle>
						<Row>
							<Col md="9">
								<InputGeral
									label={"Empresa"}
									value={empresa.M0_FILIAL}
									tipo={"text"}
									disabled={true}
								/>
							</Col>
							<Col md="3">
								<InputGeral
									label={"CNPJ"}
									value={empresa.M0_CGC}
									tipo={"text"}
									disabled={true}
								/>
							</Col>
						</Row>
						<Row>
							<Col md="2">
								<InputGeral
									label={"CEP"}
									value={empresa.M0_CEPENT.trim() }
									tipo={"text"}
									disabled={true}
								/>
							</Col>
							<Col md="4">
								<InputGeral
									label={"Endereço"}
									value={empresa.M0_ENDENT.trim()}
									tipo={"text"}
									disabled={true}
								/>
							</Col>
							<Col md="3">
								<InputGeral
									label={"Bairro"}
									value={empresa.M0_BAIRENT.trim() }
									tipo={"text"}
									disabled={true}
								/>
							</Col>
							<Col md="3">
								<InputGeral
									label={"Município - UF"}
									value={empresa.M0_CIDENT.trim() + ' - ' + empresa.M0_ESTENT }
									tipo={"text"}
									disabled={true}
								/>
							</Col>
						</Row>
					</div>
					<div className="container mt-4">
						<SubTitle>Dados de Entrega</SubTitle>
						<Row>
							<Col md="7">
								<InputGeral
									label={"Endereço Entrega"}
									bindItem={produtos[0].fornecedores[0]}
									field={"enderecoFrete"}
									value={produtos[0].fornecedores[0].enderecoFrete}
									tipo={"text"}
									disabled={true}
								/>
							</Col>
							<Col md="2">
								<SelectFixo 
									options={[{
										value: 'C',
										text: "CIF",
									},
									{
										value: 'F',
										text: "FOB",
									}]}
									isLabel={true} 
									label="Tipo Frete"
									onChange={(e) => { handleChangeTipoFrete(e, produtos, setProdutos) }}
									selectedOptionValue={produtos[0].fornecedores[0].tipoFrete}
									value={produtos[0].fornecedores[0].tipoFrete}
									disabled={!produtos[0].fornecedores[0].habilitadoDigitar}
								/>
							</Col>
							{ produtos[0].fornecedores[0].tipoFrete?.value !== 'C' &&
								<Col md="3">
									<InputGeral
										isLabel={true}
										label="Valor Frete"
										tipo={"monetario"}
										bindItem={produtos[0].fornecedores[0]}
										field={"frete"}
										idComponente={"TOTALFRETE_" + produtos[0].fornecedores[0].chaveSC8}
										onChange={(e, value) => { handleChangeDataFornecedor(produtos[0].fornecedores[0], produtos, setProdutos, 0, false, undefined, value) }}
										disabled={!produtos[0].fornecedores[0].habilitadoDigitar}
									/>
								</Col>
							}
						</Row>
					</div>
					<TableWrapper>
						<TableBoot striped bordered responsive={true}
							style={{ width: "96vw"}}							
						>
							<thead>
								<tr>
									<ThFixed left="0px" zIndex={3} minWidth="25vw">Produto</ThFixed>
									<ThFixed left="25vw" zIndex={3}>Quantidade</ThFixed>
									{produtos[0].fornecedores.map( (fornecedor, idx) => (
										<>
											{ (	( !CotacaoTela ) || 
												( campoExibeMapa[0].value === "Todos" ) || 
												( CotacaoTela && campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
												( CotacaoTela && !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
												<TableCell key={idx} colSpan={3}>
													<Row>
														<Col md="12">
															<TableText>
																{fornecedor.nome} ({fornecedor.cnpj}) { CotacaoTela && ( <>{fornecedor.respondido ? '' : " - Não Respondido"}</>) }
																<br/>
															</TableText>
														</Col> 														
													</Row>
												</TableCell>
											}
										</>
									))}
								</tr>
							</thead>
							<tbody>
								{produtos.map((produto, index) => (
								<tr key={index}>
									<TdFixed left="0px" zIndex={2} minWidth="25vw">
										<p>
											{ produto.anexoProduto && produto.anexoProduto.length > 0 &&
												<NormalFont tooltipText={"Anexo do Item"} onClick={()=> showAnexoItem(produto.anexoProduto)}><IconComponent icon={"MdOutlineAttachFile"}/></NormalFont> 
											}
											{produto.nome} ({produto.codigo})
										</p>
										{produto.descricaoComplementar && produto.descricaoComplementar.trim() && (<p><strong>Desc. Compl.: </strong>{produto.descricaoComplementar}</p>) }
										{produto.certificado && produto.certificado.trim() && (<p><strong>CA: </strong>{produto.certificado}</p>) }

										<div>
											<strong>Observação Produto: </strong>
											<InputGeral
												tipo="textArea"
												bindItem={produtos[index].fornecedores[0]}
												field={"observacaoItem"}
												idComponente={"OBSITEM_" + produtos[index].fornecedores[0].chaveSC8}
												onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[0], produtos, setProdutos, index) }}
												disabled={!produtos[index].fornecedores[0].habilitadoDigitar}
												rowSpace={8}
											/>
										</div>
									</TdFixed>
									<TdFixed left="25vw" zIndex={2} minWidth="150px">
										<p>{formatarComoDecimal(parseLocaleNumber(produto.quantidade),4)} {produto.unidade}</p>
										{ produto.periodo && ( <p>{produto.periodo}: {produto.tempo}</p>) }
										<div>
											<strong>Necessidade Entrega</strong>
											<InputGeral
												tipo="date"
												disabled={true}
												bindItem={produtos[index]}
												field={"dataPrevisao"}										
											/>
										</div>
									</TdFixed>
									{produto.fornecedores.map((fornecedor, idx) => (
										<>
											{ (	( !CotacaoTela ) || 
												( campoExibeMapa[0].value === "Todos" ) || 
												( CotacaoTela && campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
												( CotacaoTela && !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
												<td key={idx} colSpan={1}>
													<SubTableFor>
													<tbody>
														<SubTableRow>
															<SubTableForCell>
																<strong>Preço Unitário</strong>
																<InputGeral
																	tipo="monetario"
																	decimal={4}
																	bindItem={produtos[index].fornecedores[idx]}
																	field={"valor"}
																	idComponente={"VALOR_" + fornecedor.chaveSC8}
																	onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																	disabled={!fornecedor.habilitadoDigitar}
																/>
															</SubTableForCell>
															<SubTableForCell>
																<strong >Total</strong>
																<InputGeral
																	tipo="monetario"
																	decimal={2}
																	disabled={true}
																	bindItem={produtos[index].fornecedores[idx]}
																	field={"valorTotal"}
																	styleComponent={produtos[index].fornecedores[idx].isMenorPreco ? { background: 'green' } : undefined}
																/>
															</SubTableForCell>
														</SubTableRow>
														<SubTableRow>
															<SubTableForCell>
																<strong>ICMS</strong>
																<InputGeral
																	tipo="monetario"
																	decimal={2}
																	bindItem={produtos[index].fornecedores[idx]}
																	field={"valorICMS"}
																	idComponente={"ICMS_" + fornecedor.chaveSC8}
																	onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																	disabled={!fornecedor.habilitadoDigitar}
																/>
															</SubTableForCell>
															<SubTableForCell>
																<strong>ICMS ST</strong>
																<InputGeral
																	tipo="monetario"
																	decimal={2}
																	bindItem={produtos[index].fornecedores[idx]}
																	field={"valorICMSST"}
																	idComponente={"ICMSST_" + fornecedor.chaveSC8}
																	onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																	disabled={!fornecedor.habilitadoDigitar}
																/>
															</SubTableForCell>
														</SubTableRow>
														<SubTableRow>
															<SubTableForCell>
																<strong>IPI</strong>
																<InputGeral
																	tipo="monetario"
																	decimal={2}
																	bindItem={produtos[index].fornecedores[idx]}
																	field={"valorIPI"}
																	idComponente={"IPI_" + fornecedor.chaveSC8}
																	onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																	disabled={!fornecedor.habilitadoDigitar}
																/>
															</SubTableForCell>
															<SubTableForCell>
																<strong>DIFAL</strong>
																<InputGeral
																	tipo="monetario"
																	decimal={2}
																	bindItem={produtos[index].fornecedores[idx]}
																	field={"valorDIFAL"}
																	idComponente={"DIFAL_" + fornecedor.chaveSC8}
																	onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																	disabled={!fornecedor.habilitadoDigitar}
																/>
															</SubTableForCell>
														</SubTableRow>
														<SubTableRow>
															<SubTableForCell>
																<strong>ISS</strong>
																<InputGeral
																	tipo="monetario"
																	decimal={2}
																	bindItem={produtos[index].fornecedores[idx]}
																	field={"valorISS"}
																	idComponente={"ISS_" + fornecedor.chaveSC8}
																	onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																	disabled={!fornecedor.habilitadoDigitar}
																/>
															</SubTableForCell>
															<SubTableForCell>
																<strong>Data Entrega</strong>
																<InputGeral
																	tipo="date"
																	bindItem={produtos[index].fornecedores[idx]}
																	field={"dataEntrega"}
																	idComponente={"DTENTREGA_" + fornecedor.chaveSC8}
																	onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																	disabled={!fornecedor.habilitadoDigitar}
																	min={dataMinima}
																/>
															</SubTableForCell>
														</SubTableRow>														
														<SubTableRow>														
															<SubTableForCell>
																<strong>CA Fornecedor</strong>
																<InputGeral
																	tipo="text"
																	decimal={2}
																	bindItem={produtos[index].fornecedores[idx]}
																	field={"CA"}
																	idComponente={"CA_" + fornecedor.chaveSC8}
																	onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																	disabled={!fornecedor.habilitadoDigitar}
																/>
															</SubTableForCell>
														</SubTableRow>														
													</tbody>
													</SubTableFor>
												</td>
											}
										</>
									))}
								</tr>
								))}
								<tr>
									<TdFixed left="0px" zIndex={2} minWidth="25vw" colSpan={2}>Total Cotação Fornecedor:</TdFixed>
									{produtos[0].fornecedores.map((fornecedor, idx) => (
										<>
											{ (	( !CotacaoTela ) || 
												( campoExibeMapa[0].value === "Todos" ) || 
												( campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
												( !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
												<td key={idx} >
													<InputGeral
														tipo="monetario"
														decimal={4}
														disabled={true}
														bindItem={produtos[0].fornecedores[idx]}
														field={"totalFornecedor"}
														idComponente={"TOTFORN_" + produtos[0].fornecedores[idx].chaveFornecedor}
														onChange={(e) => { handleChangeDataFornecedor(produtos[0].fornecedores[idx], produtos, setProdutos, 0, false) }}
													/>
												</td>
											}
										</>
									))}
								</tr>
								<tr>
									<TdFixed left="0px" zIndex={2} minWidth="25vw" colSpan={2}>Data Validade:</TdFixed>
									{produtos[0].fornecedores.map((fornecedor, idx) => (
										<>
											{ (	( !CotacaoTela ) || 
												( campoExibeMapa[0].value === "Todos" ) || 
												( campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
												( !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
												<td key={idx} >
													<InputGeral
														tipo="date"
														bindItem={produtos[0].fornecedores[idx]}
														field={"dataValidade"}
														idComponente={"DTVALIDADE_" + produtos[0].fornecedores[idx].chaveFornecedor}
														onChange={(e) => { handleChangeDataFornecedor(produtos[0].fornecedores[idx], produtos, setProdutos, 0, false) }}
														disabled={!fornecedor.habilitadoCamposExtras}
													/>
												</td>
											}
										</>
									))}
								</tr>
								<tr>
									<TdFixed left="0px" zIndex={2} minWidth="25vw" colSpan={2}>Condição de Pagamento:</TdFixed>
									{produtos[0].fornecedores.map((fornecedor, idx) => (
										<>
											{ (	( !CotacaoTela ) || 
												( campoExibeMapa[0].value === "Todos" ) || 
												( campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
												( !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
												<td key={idx} >
													<SelectCondicaoPagamento
														queryCondPagto={cConsultaCondPgto}
														empresaLogada={empresaFilial}
														showLabel={false}
														bindItem={produtos[0].fornecedores[idx]}
														field={"condicaoPagamento"}
														idComponente={"CONDPAGTO_" + produtos[0].fornecedores[idx].chaveFornecedor}
														changeCondPagto={(e) => { handleChangeDataFornecedor(produtos[0].fornecedores[idx], produtos, setProdutos, 0, false) }}
														disabled={!fornecedor.habilitadoCamposExtras}
													/>
												</td>
											}
										</>
									))}
								</tr>
								<tr>
									<TdFixed left="0px" zIndex={2} minWidth="25vw" colSpan={2}>Observações de Pagamento:</TdFixed>
									{produtos[0].fornecedores.map((fornecedor, idx) => (
										<>
											{ (	( !CotacaoTela ) || 
												( campoExibeMapa[0].value === "Todos" ) || 
												( campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
												( !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
												<td key={idx} >
													<InputGeral
														tipo="textArea"
														bindItem={produtos[0].fornecedores[idx]}
														field={"observacaoFornecedor"}
														idComponente={"OBSPAGTO_" + produtos[0].fornecedores[idx].chaveFornecedor}
														onChange={(e) => { handleChangeDataFornecedor(produtos[0].fornecedores[idx], produtos, setProdutos, 0, false) }}
														disabled={!fornecedor.habilitadoCamposExtras}
													/>
												</td>
											}
										</>
									))}
								</tr>
								<tr>
									<TdFixed left="0px" zIndex={2} minWidth="25vw" colSpan={2}>Anexo da Proposta:</TdFixed>
									{produtos[0].fornecedores.map((fornecedor, idx) => (									
										<>
											{ (	( !CotacaoTela ) || 
												( campoExibeMapa[0].value === "Todos" ) || 
												( campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
												( !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
												<td key={idx} >
													<UploadFiles 												
														onDropEvent={handleAddFilesProposta}
														onDeleteEvent={handleDelFilesProposta}
														value={anexoProposta}
														disabled={!fornecedor.habilitadoCamposExtras}
													/>
												</td>
											}
										</>
									))}
								</tr>
								<tr>
									<td colSpan={3}>
										<div className="container mt-4">
											<ul className="ps-4">
												<CustomizeLI>
												O prazo de pagamento se dará em dias corridos a contar da data da entrega dos materiais ou da emissão da nota fiscal 
												/ fatura de serviços / locação, sendo que a efetivação do pagamento ocorrerá às 
												<strong> segunda-feira</strong> imediatamente após o vencimento ou nas 
												<strong> quarta-feira</strong>, quando ocorrer o vencimento na terça-feira.
												</CustomizeLI>
												<CustomizeLI>
												O pagamento será efetuado mediante crédito na conta corrente do <strong>FORNECEDOR</strong> a ser informada na nota fiscal, 
												servindo o comprovante de depósito como prova de pagamento e quitação da quantia devida.
												</CustomizeLI>
												<CustomizeLI>
												O <strong>FORNECEDOR</strong> renuncia expressamente ao que lhe faculta o Artigo 2º da Lei nº 5474/68, portanto fica vedada 
												a extração de duplicata da fatura emitida em razão das notas fiscais/faturas, bem como o desconto de títulos em bancos e 
												instituições financeiras ou factoring, levar título à protesto, dar esse Pedido de Compra em garantia, sem a prévia e 
												expressa autorização da NPE.
												</CustomizeLI>
											</ul>
										</div>
									</td>
								</tr>
							</tbody>
						</TableBoot>
					</TableWrapper>
				</>
			)}
			{ produtos && produtos.length > 0 && CotacaoTela && (
				<MapaScrollArea role="region" aria-label="Mapa comparativo de cotação">
					<MapaTable striped bordered>
						<colgroup>
							<col className="mapa-col-produto" />
							<col className="mapa-col-quantidade" />
							{fornecedoresVisiveisMapa.map((fornecedor) => (
								<col key={fornecedor.chaveFornecedor} className="mapa-col-fornecedor" />
							))}
						</colgroup>
						<TheadFixed>
							<tr>
								<ThFixed className="mapa-col-produto" left="0px" zIndex={6}>Produto</ThFixed>
								
								<ThFixed className="mapa-col-quantidade" left="var(--mapa-produto-largura)" zIndex={6}>Quantidade</ThFixed>
								{produtos[0].fornecedores.map( (fornecedor, idx) => (
									<>
										{ (	( !CotacaoTela ) || 
											( campoExibeMapa[0].value === "Todos" ) || 
											( CotacaoTela && campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
											( CotacaoTela && !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
											<TableCell key={idx} className="mapa-col-fornecedor" colSpan={1}>
												<Row>
													{ produtos[0].habilitaSelecionar && (
														<Col md="1">
															<InputGeral
																styleComponent={{fontSize: '10px'}}
																tipo="caixaSelecao"
																decimal={4}
																bindItem={produtos[0].fornecedores[idx]}
																field={"selecionadoFornecedor"}
																idComponente={"FORNECEDOR_SELECIONADO_" + fornecedor.chaveSC8}
																onChange={(e, valor) => { handleChangeSelecionadoAll(fornecedor, produtos, setProdutos, valor) }}																
															/>
														</Col>
													)}

													<Col md="2">
														<BlackFont tooltipText={"Anexo para Digitação manual"} onClick={()=> handleHabilitaDigitar(fornecedor.chaveFornecedor, fornecedor.anexoMapa)}><IconComponent icon={"MdOutlineAttachFile"}/></BlackFont> 
													</Col>
													<Col md="7">
														<TableText>
															{/* //Selecionar Todos do Fornecedor */}															
															{fornecedor.nome} ({fornecedor.cnpj}) { CotacaoTela && ( <>{fornecedor.respondido ? '' : " - Não Respondido"}</>) }
														</TableText>
														<br/>
														<TableText>
															{ CotacaoTela && (
																<>Cond.: {fornecedor.condPadrao}</>
															)}
														</TableText>
													</Col> 
													<Col md="1">
														<ExpandButton onClick={() => handleToggleExpand(fornecedor.cnpj) } >
															{expanded[`${fornecedor.cnpj}`] ? '▲' : '▼'}
														</ExpandButton>
													</Col>
												</Row>
											</TableCell>
										}
									</>
								))}
							</tr>
						</TheadFixed>
						<tbody>
							{produtos.map((produto, index) => (
							<tr key={index}>
								<TdFixed className="mapa-col-produto" left="0px" zIndex={3}>
									<span>
										{produto.fornecedores.some( (item) => item.selecionado === true) && (<IconComponent styled={{color: 'green'}} icon={"FaCheckCircle"} />)}&nbsp;
										{ produto.anexoProduto && produto.anexoProduto.length > 0 &&
											<NormalFont tooltipText={"Anexo do Item"} onClick={()=> showAnexoItem(produto.anexoProduto)}><IconComponent icon={"MdOutlineAttachFile"}/></NormalFont> 
										}
										{produto.nome} <NormalFont tooltipText={`Ultimas Compras Produto: ${produto.codigo}`} onClick={(e) => handleHistorico(produtos[index])} >({produto.codigo})</NormalFont>
									</span>
									{produto.descricaoComplementar && produto.descricaoComplementar.trim() && (<p><strong>Desc. Compl.: </strong>{produto.descricaoComplementar}</p>) }
									{produto.certificado && produto.certificado.trim() && (<p><strong>CA: </strong>{produto.certificado}</p>) }
									{produto.centroCusto && produto.centroCusto.trim() && (<p><strong>CC: </strong>{produto.centroCusto}</p>) }
								</TdFixed>
								<TdFixed className="mapa-col-quantidade" left="var(--mapa-produto-largura)" zIndex={3}>
									{produto.fornecedores.some( (item) => !item.numeroContrato.trim() && !item.numeroPedido.trim()) && 
										<NormalFont styled={{width: '100%', TextAlign: "end"}} tooltipText={"Desmembrar Quantidade"} onClick={()=> handleDesmembraItem(produto.itemId, produto.numSC, produto.itemSC, produto.quantidade, produto.nome)}>{produto.quantidade} {produto.unidade}</NormalFont> 
									}
									{ produto.periodo && ( <p>{produto.periodo}: {produto.tempo}</p>) }
									{!produto.fornecedores.some( (item) => !item.numeroContrato.trim() && !item.numeroPedido.trim()) && 
										<p>{formatarComoDecimal(parseLocaleNumber(produto.quantidade),4)} {produto.unidade}</p>
									}
									<div>
										<strong>Necessidade Entrega</strong>
										<InputGeral
											styleComponent={{fontSize: '10px'}}
											tipo="date"
											disabled={true}
											bindItem={produtos[index]}
											field={"dataPrevisao"}										
										/>
									</div>
								</TdFixed>
								{produto.fornecedores.map((fornecedor, idx) => (
									<>
										{ (	( !CotacaoTela ) || 
											( campoExibeMapa[0].value === "Todos" ) || 
											( CotacaoTela && campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
											( CotacaoTela && !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
											<DadosTD key={idx} className="mapa-col-fornecedor" colSpan={1} even={idx}>
												<SubTable>
												<tbody>
													<SubTableRow>
														<SubTableCell>
															{ (fornecedor.numeroContrato.trim() && fornecedor.numeroContrato !== 'XXXXXXXXXXXXXXX') && 
																<>
																	<strong>Nº. Contrato</strong>
																	<InputGeral
																		styleComponent={{fontSize: '10px'}}
																		tipo="text"
																		decimal={4}
																		bindItem={produtos[index].fornecedores[idx]}
																		field={"numeroContrato"}
																		idComponente={"Contrato_" + fornecedor.chaveSC8}
																		disabled={true}
																		/>
																	</>
																}
															{ (fornecedor.numeroPedido.trim() && fornecedor.numeroPedido !== 'XXXXXX') && 
																<>
																	<strong>Nº. Pedido</strong>
																	<InputGeral
																		styleComponent={{fontSize: '10px'}}
																		tipo="text"
																		decimal={4}
																		bindItem={produtos[index].fornecedores[idx]}
																		field={"numeroPedido"}
																		idComponente={"Pedido_" + fornecedor.chaveSC8}
																		disabled={true}
																	/>
																</>
															}
															{ (!fornecedor.numeroContrato.trim() && !fornecedor.numeroPedido.trim()) && 
																<InputGeral
																	styleComponent={{fontSize: '10px'}}
																	tipo="caixaSelecao"
																	decimal={4}
																	bindItem={produtos[index].fornecedores[idx]}
																	field={"selecionado"}
																	idComponente={"SELECIONADO_" + fornecedor.chaveSC8}
																	onChange={(e, valor) => { handleChangeSelecionado(valor, produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																	disabled={!produtos[index].habilitaSelecionar}
																/>
															}
														</SubTableCell>
														<SubTableCellLarger>
															<NormalFont tooltipText="Histórico" onClick={(e) => handleHistorico(produtos[index], fornecedor)}><IconComponent icon={"PiUserList"} /></NormalFont>
															{ fornecedor.preco > 0 && fornecedor.ultimoPreco > 0 && fornecedor.preco > fornecedor.ultimoPreco && 
																<RedFont tooltipText={`Valor Maior que Ultimo Preço do Fornecedor - ${formatarComoMoeda(fornecedor.ultimoPreco)}`}><IconComponent icon={"FaArrowUpShortWide"} /></RedFont>
															}
															{ fornecedor.preco > 0 && fornecedor.ultimoPreco > 0 && fornecedor.preco < fornecedor.ultimoPreco && 
																<GreenFont tooltipText={`Valor Menor que Ultimo Preço do Fornecedor  - ${formatarComoMoeda(fornecedor.ultimoPreco)}`}><IconComponent icon={"FaArrowDownShortWide"} /></GreenFont>
															}
															{ ( fornecedor.preco === fornecedor.ultimoPreco || fornecedor.preco === 0 || fornecedor.ultimoPreco === 0 ) && 
																<NormalFont tooltipText={`Valor igual ao Ultimo Preço do Fornecedor  - ${formatarComoMoeda(fornecedor.ultimoPreco)}`}><IconComponent icon={"FaArrowDownUpAcrossLine"} /></NormalFont>
															}
															{ fornecedor.preco > 0 && fornecedor.ultimoPrecoGeral > 0 && fornecedor.preco > fornecedor.ultimoPrecoGeral && 
																<RedFont tooltipText={`Valor Maior que Ultimo Preço do Produto - ${formatarComoMoeda(fornecedor.ultimoPrecoGeral)}`}><IconComponent icon={"FaArrowUpShortWide"} /></RedFont>
															}
															{ fornecedor.preco > 0 && fornecedor.ultimoPrecoGeral > 0 && fornecedor.preco < fornecedor.ultimoPrecoGeral && 
																<GreenFont tooltipText={`Valor Menor que Ultimo Preço do Produto - ${formatarComoMoeda(fornecedor.ultimoPrecoGeral)}`}><IconComponent icon={"FaArrowDownShortWide"} /></GreenFont>
															}
															{ ( fornecedor.preco === fornecedor.ultimoPrecoGeral || fornecedor.preco === 0 || fornecedor.ultimoPrecoGeral === 0 ) && 
																<NormalFont tooltipText={`Valor igual ao Ultimo Preço do Produto - ${formatarComoMoeda(fornecedor.ultimoPrecoGeral)}`}><IconComponent icon={"FaArrowDownUpAcrossLine"} /></NormalFont>
															}
															{ fornecedor.observacaoItem.trim() &&
																<NormalFont tooltipText="Observação do Fornecedor para o Item" onClick={(e) => handleObservacao(fornecedor.observacaoItem)}><IconComponent icon={"MdOutlineDescription"} /></NormalFont>
															}
														</SubTableCellLarger>
													</SubTableRow>
													<SubTableRow>
														<SubTableCell>
															<NormalFont tooltipText="Histórico Cotação" onClick={(e) => handleHistoricoItem(fornecedor.chaveSC8)}>Preço Unitário</NormalFont>
															<InputGeral
																styleComponent={{fontSize: '10px'}}
																tipo="monetario"
																decimal={4}
																bindItem={produtos[index].fornecedores[idx]}
																field={"valor"}
																idComponente={"VALOR_" + fornecedor.chaveSC8}
																onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																disabled={!fornecedor.habilitadoDigitar}
															/>
														</SubTableCell>
														<SubTableCell>
															<NormalFont>Total</NormalFont>
															<InputGeral
																tipo="monetario"
																decimal={2}
																disabled={true}
																bindItem={produtos[index].fornecedores[idx]}
																field={"valorTotal"}
																styleComponent={produtos[index].fornecedores[idx].isMenorPreco ? { background: 'green', fontSize: '10px' } : { fontSize: '10px' }}
															/>
														</SubTableCell>
													</SubTableRow>
													{ expanded[`${fornecedor.cnpj}`] && (
													<>
													<SubTableRow>
														<SubTableCell>
															<strong>ICMS</strong>
															<InputGeral
																styleComponent={{fontSize: '10px'}}
																tipo="monetario"
																decimal={2}
																bindItem={produtos[index].fornecedores[idx]}
																field={"valorICMS"}
																idComponente={"ICMS_" + fornecedor.chaveSC8}
																onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																disabled={!fornecedor.habilitadoDigitar}
															/>
														</SubTableCell>
														<SubTableCell>
															<strong>ICMS ST</strong>
															<InputGeral
																styleComponent={{fontSize: '10px'}}
																tipo="monetario"
																decimal={2}
																bindItem={produtos[index].fornecedores[idx]}
																field={"valorICMSST"}
																idComponente={"ICMSST_" + fornecedor.chaveSC8}
																onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																disabled={!fornecedor.habilitadoDigitar}
															/>
														</SubTableCell>
													</SubTableRow>
													<SubTableRow>
														<SubTableCell>
															<strong>IPI</strong>
															<InputGeral
																styleComponent={{fontSize: '10px'}}
																tipo="monetario"
																decimal={2}
																bindItem={produtos[index].fornecedores[idx]}
																field={"valorIPI"}
																idComponente={"IPI_" + fornecedor.chaveSC8}
																onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																disabled={!fornecedor.habilitadoDigitar}
															/>
														</SubTableCell>
														<SubTableCell>
															<strong>DIFAL</strong>
															<InputGeral
																styleComponent={{fontSize: '10px'}}
																tipo="monetario"
																decimal={2}
																bindItem={produtos[index].fornecedores[idx]}
																field={"valorDIFAL"}
																idComponente={"DIFAL_" + fornecedor.chaveSC8}
																onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																disabled={!fornecedor.habilitadoDigitar}
															/>
														</SubTableCell>
													</SubTableRow>
													<SubTableRow>
														<SubTableCell>
															<strong>ISS</strong>
															<InputGeral
																styleComponent={{fontSize: '10px'}}
																tipo="monetario"
																decimal={2}
																bindItem={produtos[index].fornecedores[idx]}
																field={"valorISS"}
																idComponente={"ISS_" + fornecedor.chaveSC8}
																onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																disabled={!fornecedor.habilitadoDigitar}
															/>
														</SubTableCell>
														<SubTableCell>
															<strong>Data Entrega</strong>
															<InputGeral
																styleComponent={{fontSize: '10px'}}
																tipo="date"
																bindItem={produtos[index].fornecedores[idx]}
																field={"dataEntrega"}
																idComponente={"DTENTREGA_" + produtos[index].fornecedores[idx].chaveSC8}
																onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																disabled={!produtos[index].fornecedores[idx].habilitadoDigitar}
																min={dataMinima}
															/>
														</SubTableCell>
													</SubTableRow>													
													<SubTableRow>													
														<SubTableCell>
															<strong>CA Fornecedor</strong>
															<InputGeral
																tipo="text"
																bindItem={produtos[index].fornecedores[idx]}
																field={"CA"}
																idComponente={"CA_" + produtos[index].fornecedores[idx].chaveSC8}
																onChange={(e) => { handleChangeDataFornecedor(produtos[index].fornecedores[idx], produtos, setProdutos, index) }}
																disabled={!produtos[index].fornecedores[idx].habilitadoDigitar}
															/>
														</SubTableCell>
													</SubTableRow>
													</>
													)}													
												</tbody>
												</SubTable>
											</DadosTD>
										}
									</>
								))}
							</tr>
							))}
							<tr>
								<TdFixed className="mapa-col-resumo" left="0px" zIndex={3} colSpan={2}>Total Cotação Fornecedor:</TdFixed>
								{produtos[0].fornecedores.map((fornecedor, idx) => (
									<>
										{ (	( !CotacaoTela ) || 
											( campoExibeMapa[0].value === "Todos" ) || 
											( campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
											( !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
											<DadosTD key={idx} className="mapa-col-fornecedor" colSpan={1} even={idx}>
												<InputGeral
													styleComponent={{fontSize: '10px'}}
													tipo="monetario"
													decimal={4}
													disabled={true}
													bindItem={produtos[0].fornecedores[idx]}
													field={"totalFornecedor"}
													idComponente={"TOTFORN_" + produtos[0].fornecedores[idx].chaveFornecedor}
													onChange={(e) => { handleChangeDataFornecedor(produtos[0].fornecedores[idx], produtos, setProdutos, 0, false) }}
												/>
											</DadosTD>
										}
									</>
								))}
							</tr>
							<tr>
								<TdFixed className="mapa-col-resumo" left="0px" zIndex={3} colSpan={2}>Total Selecionados:</TdFixed>
								{produtos[0].fornecedores.map((fornecedor, idx) => (
									<>
										{ (	( campoExibeMapa[0].value === "Todos" ) || 
											( campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
											( !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
												<DadosTD key={idx} className="mapa-col-fornecedor" colSpan={1} even={idx}>
													<InputGeral
														styleComponent={{fontSize: '10px'}}
														tipo="monetario"
														decimal={4}
														disabled={true}
														bindItem={produtos[0].fornecedores[idx]}
														field={"totalSelecionado"}
														idComponente={"TOTSELFORN_" + produtos[0].fornecedores[idx].chaveFornecedor}
														onChange={(e) => { handleChangeDataFornecedor(produtos[0].fornecedores[idx], produtos, setProdutos, 0, false) }}
													/>
												</DadosTD>
										}
									</>
								))}
							</tr>
							<tr>
								<TdFixed className="mapa-col-resumo" left="0px" zIndex={3} colSpan={2}>Tipo Frete:</TdFixed>
								{produtos[0].fornecedores.map((fornecedor, idx) => (
									<>
										{ (	( campoExibeMapa[0].value === "Todos" ) || 
											( campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
											( !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
											<DadosTD key={idx} colSpan={1} even={idx} style={{fontVariantCaps: 'all-petite-caps'}}>
												<SelectFixo 
													options={[{
														value: 'C',
														text: "CIF",
													},
													{
														value: 'F',
														text: "FOB",
													}]}
													isLabel={true}
													onChange={(e) => { handleChangeTipoFrete(e, produtos, setProdutos, idx) }}
													selectedOptionValue={produtos[0].fornecedores[idx].tipoFrete}
													value={produtos[0].fornecedores[idx].tipoFrete}
													disabled={!fornecedor.habilitadoCamposExtras}
													styleAux={{fontSize: '10px'}}
												/>
											</DadosTD>
										}
									</>
								))}
							</tr>
							<tr>
								<TdFixed className="mapa-col-resumo" left="0px" zIndex={3} colSpan={2}>Valor Frete:</TdFixed>
								{ produtos[0].fornecedores.map((fornecedor, idx) => (
									<>
										{ (	( campoExibeMapa[0].value === "Todos" ) || 
											( campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
											( !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
											<DadosTD key={idx} className="mapa-col-fornecedor" colSpan={1} even={idx}>
												<InputGeral
													tipo={"monetario"}
													bindItem={produtos[0].fornecedores[idx]}
													field={"frete"}
													idComponente={"VALORFRETE_" + fornecedor.chaveSC8}
													onChange={(e, value) => { handleChangeDataFornecedor(produtos[0].fornecedores[idx], produtos, setProdutos, 0, false, undefined, value) }}
													disabled={(!fornecedor.habilitadoDigitar)}
													styleComponent={{fontSize: '10px'}}
												/>
											</DadosTD>
										}
									</>
								))}
							</tr>
							<tr>
								<TdFixed className="mapa-col-resumo" left="0px" zIndex={3} colSpan={2}>Data Validade:</TdFixed>
								{produtos[0].fornecedores.map((fornecedor, idx) => (
									<>
										{ (	( !CotacaoTela ) || 
											( campoExibeMapa[0].value === "Todos" ) || 
											( campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
											( !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
											<DadosTD key={idx} className="mapa-col-fornecedor" colSpan={1} even={idx}>
												<InputGeral
													tipo="date"
													bindItem={produtos[0].fornecedores[idx]}
													field={"dataValidade"}
													idComponente={"DTVALIDADE_" + produtos[0].fornecedores[idx].chaveFornecedor}
													onChange={(e) => { handleChangeDataFornecedor(produtos[0].fornecedores[idx], produtos, setProdutos, 0, false) }}
													disabled={!fornecedor.habilitadoCamposExtras}
													styleComponent={{fontSize: '10px'}}
												/>
											</DadosTD>
										}
									</>
								))}
							</tr>
							<tr>
								<TdFixed className="mapa-col-resumo" left="0px" zIndex={3} colSpan={2}>Condição de Pagamento:</TdFixed>
								{produtos[0].fornecedores.map((fornecedor, idx) => (
									<>
										{ (	( !CotacaoTela ) || 
											( campoExibeMapa[0].value === "Todos" ) || 
											( campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
											( !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
											<DadosTD key={idx} colSpan={1} even={idx} style={{fontVariantCaps: 'all-petite-caps'}}>
												<SelectCondicaoPagamento
													queryCondPagto={cConsultaCondPgto}
													empresaLogada={empresaFilial}
													showLabel={false}
													bindItem={produtos[0].fornecedores[idx]}
													field={"condicaoPagamento"}
													idComponente={"CONDPAGTO_" + produtos[0].fornecedores[idx].chaveFornecedor}
													changeCondPagto={(e) => { handleChangeDataFornecedor(produtos[0].fornecedores[idx], produtos, setProdutos, 0, false) }}
													disabled={!fornecedor.habilitadoCamposExtras}																							
												/>
											</DadosTD>
										}
									</>
								))}
							</tr>
							<tr>
								<TdFixed className="mapa-col-resumo" left="0px" zIndex={3} colSpan={2}>Observações de Pagamento:</TdFixed>
								{produtos[0].fornecedores.map((fornecedor, idx) => (
									<>
										{ (	( !CotacaoTela ) || 
											( campoExibeMapa[0].value === "Todos" ) || 
											( campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
											( !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
											<DadosTD key={idx} className="mapa-col-fornecedor" colSpan={1} even={idx}>
												<InputGeral
													tipo="textArea"
													bindItem={produtos[0].fornecedores[idx]}
													field={"observacaoFornecedor"}
													idComponente={"OBSPAGTO_" + produtos[0].fornecedores[idx].chaveFornecedor}
													onChange={(e) => { handleChangeDataFornecedor(produtos[0].fornecedores[idx], produtos, setProdutos, 0, false) }}
													disabled={!fornecedor.habilitadoCamposExtras}
												/>
											</DadosTD>
										}
									</>
								))}
							</tr>
							<tr>
								<TdFixed className="mapa-col-resumo" left="0px" zIndex={3} colSpan={2}>Observação Fornecedor:</TdFixed>
								{produtos[0].fornecedores.map((fornecedor, idx) => (
									<>
										{ (	( campoExibeMapa[0].value === "Todos" ) || 
											( campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
											( !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
											<DadosTD key={idx} className="mapa-col-fornecedor" colSpan={1} even={idx}>
												<InputGeral
													tipo="textArea"
													bindItem={produtos[0].fornecedores[idx]}
													field={"observacaoMapa"}
													idComponente={"OBSFORN_" + produtos[0].fornecedores[idx].chaveFornecedor}
													onChange={(e) => { handleChangeDataFornecedor(produtos[0].fornecedores[idx], produtos, setProdutos, 0, false) }}
													disabled={finalizado}
												/>
											</DadosTD>
										}
									</>
								))}
							</tr>
							<tr>
								<TdFixed className="mapa-col-resumo" left="0px" zIndex={3} colSpan={2}>Justificativa:</TdFixed>
								{produtos[0].fornecedores.map((fornecedor, idx) => (
									<>
										{ (	( campoExibeMapa[0].value === "Todos" ) || 
											( campoExibeMapa[0].value === "Respondidos" && fornecedor.respondido ) ||
											( !/Todos|Respondidos/.test(campoExibeMapa.map( (item) => item.value).join(';')) && campoExibeMapa.map( (item) => item.value).join(';').includes(fornecedor.chaveFornecedor) ) ) &&
											<DadosTD key={idx} className="mapa-col-fornecedor" colSpan={1} even={idx}>
												<InputGeral
													tipo="textArea"
													bindItem={produtos[0].fornecedores[idx]}
													field={"justificativa"}
													idComponente={"JUSTIFICATIVA_" + produtos[0].fornecedores[idx].chaveFornecedor}
													onChange={(e) => { handleChangeDataFornecedor(produtos[0].fornecedores[idx], produtos, setProdutos, 0, false) }}
													disabled={finalizado}
												/>
											</DadosTD>
										}
									</>
								))}
							</tr>
						</tbody>
					</MapaTable>
				</MapaScrollArea>
			)}
			{ !CotacaoTela && produtos && produtos.length > 0 && (
				<div className="container mt-4">
				<SubTitle>Condições Gerais:</SubTitle>
				<ul className="mt-3 ps-4">
				<CustomizeLI>
					Ao enviar a Proposta Comercial, deverá ser considerado que todo faturamento ocorrerá exclusivamente pelo 
					<strong> FORNECEDOR</strong>, não sendo permitido o faturamento por terceiros de qualquer item necessário à execução 
					do escopo desta Solicitação de Cotação.
				</CustomizeLI>
				<CustomizeLI>
					Sempre que aplicável, os valores ofertados devem contemplar a inclusão dos seguintes documentos:
					<ul className="ps-4">
					<li>Ficha de Dados de Segurança (FDS), Conforme a ABNT NBR 14725:2023 (não mais aceito a FISPQ).</li>
					<li>Certificados de Materiais, Qualidade e Relatórios de Testes Efetuados.</li>
					<li>Catálogos e manuais dos produtos.</li>
					</ul>
				</CustomizeLI>
				<CustomizeLI>
					Em atendimento ao item 8.4 das normas ISO 9001 / 45001, a NPE informa que os critérios de qualificação e avaliação 
					de fornecedor estão disponibilizados no site: 
					<a 
					href="https://www.npegroup.com.br/wp-content/uploads/2024/09/CRITERIOS-DE-QUALIFICACAO-E-AVALIACAO-DE-FORNECEDORES-NPE-1.pdf" 
					className="text-primary ms-1"
					>
					Critérios de Homologação e Avaliação de Fornecedores NPE
					</a>.
				</CustomizeLI>
				<CustomizeLI>
					As Partes se obrigam a cumprir rigorosamente os ditames da Lei nº 13.709/2018 – Lei Geral de Proteção de Dados 
					(LGPD), se comprometendo a prestarem assistência mútua com suas obrigações, no limite de suas atribuições e 
					responsabilidades, notadamente no que se refere ao dever de cautela e salvaguarda necessária para proteção dos 
					dados.
				</CustomizeLI>
				<CustomizeLI>
					O <strong>FORNECEDOR</strong> se compromete a agir com ética e transparência, obedecendo ao disposto no 
					<a 
					href="https://www.npegroup.com.br/wp-content/uploads/2024/01/Codigo-de-etica-e-conduta-de-fornecedores_NPE.pdf" 
					className="text-primary ms-1"
					>
					Código de Ética e Conduta de Fornecedores
					</a> da NPE, sob pena de reparação por perdas e danos.
				</CustomizeLI>
				</ul>
				<TextAlign>
				Pedimos que envie sua proposta dentro do prazo estipulado para garantir a inclusão no processo de análise. Caso tenha 
				dúvidas ou necessite de informações adicionais, nossa equipe está à disposição para auxiliá-lo.
				</TextAlign>
			</div>
			)}
			{ produtos && produtos.length > 0 && !propEncryptedText &&
				<SubmitForm
					labelEnviar={CotacaoTela ?  '➤ Gerar Pedido': ( expiradoData ? null : '➤ Enviar Proposta' )}		
					onEnviar={CotacaoTela ?  (finalizado ? null: handleFinalizar): ( expiradoData ? null : handleSalvar )}
					onSave={CotacaoTela ?  (finalizado ? null: handleSalvar): null }
					onVoltar={CotacaoTela ?  'handleVoltar': null }
				/>
			}
			</Container>
		</>
  	);
};

export default MapaCotacaoFornecedor;
